(function () {
  'use strict';

  var root = document.getElementById('hs-audio');
  if (!root) return;

  // ---------- Text (every message can be changed in the Theme Editor; these are the fallbacks) ----------
  var TXT = {
    "practice_title": "Practice first",
    "practice_text": "You will hear a beep in your right ear. It repeats until you answer. Press “I hear it” when you hear it.",
    "practice_auto": "You never need to change the volume during the test — the beeps get softer and louder by themselves.",
    "practice_button": "Play practice beep",
    "practice_ok": "Perfect — you heard it. The real test starts now.",
    "practice_bad": "No problem. If you heard the beep, press “I hear it”. If you heard nothing, check that your volume is at 100% and your headphones are plugged in, then play it again.",
    "status_wait": "Get ready…",
    "tap_done": "Got it ✓ — next sound coming…",
    "limit_note": "This test can measure up to about [n] dB. At the pitches marked “>”, your hearing may be weaker than that. For an exact result, book a free consultation with our specialist.",
    "tap_nudge": "Take your time — press “I hear it” if you hear a beep, or “I can’t hear it” if you hear nothing.",
    "tap_wait": "Keep listening for a moment — the beeps repeat. If you hear nothing, “I can’t hear it” will unlock.",
    "tap_early": "The sound is about to start — wait a moment.",
    "beep_no": "Sound [n]",
    "practice_listen": "Listen… the beep repeats. Press “I hear it” as soon as you hear it.",
    "practice_again": "Play again",
    "practice_skip": "Start the test anyway",
    "noise_listening": "Listening to the room for a few seconds…",
    "noise_quiet": "Quiet room — good.",
    "noise_moderate": "A little noise around. Try to switch off fans, TV or music.",
    "noise_noisy": "Quite noisy. Please move to a quieter room for a reliable result.",
    "noise_denied": "Microphone not allowed — no problem, you can continue without it.",
    "noise_unsupported": "Your browser cannot measure room noise — no problem, you can continue.",
    "noise_failed": "Could not measure the room — you can continue.",
    "meaning_good": "Soft sounds are heard well.",
    "meaning_mild": "Soft sounds and speech in noise can be missed.",
    "meaning_moderate": "Conversation can be hard to follow, especially in groups.",
    "meaning_severe": "Most speech is hard to hear without amplification.",
    "meaning_profound": "Even loud sounds are difficult to hear.",
    "avg_text": "Avg [n] dB",
    "reason_wired": "Wired headphones or earphones used.",
    "reason_bluetooth": "Bluetooth headphones can slightly change the sound.",
    "reason_speaker": "A speaker was used — headphones are needed for a reliable result.",
    "reason_check_ok": "Left / right ear check passed.",
    "reason_check_skipped": "The left / right ear check was skipped.",
    "reason_noise_quiet": "Quiet room.",
    "reason_noise_moderate": "The room was a little noisy.",
    "reason_noise_noisy": "The room was noisy — try again somewhere quieter.",
    "reason_retest_match": "Repeat 1000 Hz test matched closely.",
    "reason_retest_diff": "Your repeat 1000 Hz test differed by [n] dB.",
    "reason_retest_bad": "Your repeat 1000 Hz test differed by [n] dB — the result may be unreliable.",
    "reason_fa_high": "“I hear it” was pressed when no beep played — guessing makes results unreliable.",
    "reason_fa_some": "“I hear it” was pressed a few times when no beep played.",
    "reason_stray": "Several answers were given before any beep played.",
    "reason_nr_many": "Many tones were not heard — please double-check headphones and volume.",
    "reason_unreliable": "Some tones were hard to pin down.",
    "reason_practice": "The practice beep was not confirmed.",
    "sending_text": "Sending...",
    "submit_error": "Something went wrong — please try again or contact us.",
    "countdown_ready": "Get ready",
    "countdown_go": "Listen for beeps in your [ear]",
    "pitch_low": "Low pitch",
    "pitch_mid": "Mid pitch",
    "pitch_high": "High pitch",
    "pitch_retest": "Repeat check",
    "ear_step": "Ear [n] of 2",
    "ear_right": "right ear",
    "ear_left": "left ear",
    "booth_tip": "Press “I hear it” as soon as you hear a beep, even a very faint one.",
    "phase_find": "Finding your range",
    "phase_fine": "Fine-tuning",
    "toast_done": "✓ [f] Hz done — [n] dB",
    "toast_nr": "[f] Hz — no response",
    "toast_retest": "✓ Repeat check done",
    "speech_label": "Everyday speech",
    "lv_pitch": "Pitch",
    "lv_right": "Right",
    "lv_left": "Left",
    "lv_title": "Your result at each pitch",
    "rec_match": "Matches your result",
    "rec_empty": "No matching products yet — please see our full range.",
    "meter_title": "Sound level",
    "meter_quiet": "Quiet",
    "meter_loud": "Loud",
    "note_heard": "✓ Heard at [n] dB",
    "note_miss": "Not heard at [n] dB",
    "note_softer": "next beep is softer",
    "note_louder": "next beep is louder",
    "rec_sub": "Matched to your [loss] — best match first, then low to high price",
    "consult_title": "Not sure which one is right for you?",
    "consult_text": "Talk to our hearing specialist — it is free, online and with no obligation."
  };
  function T(key, n) {
    var v = root.getAttribute('data-t-' + key);
    if (v == null || v === '') v = TXT[key] || '';
    return n == null ? v : v.replace('[n]', n);
  }
  function flag(name, dflt) { var v = root.getAttribute('data-' + name); return v == null || v === '' ? dflt : v === 'true'; }

  // ---------- Test plan ----------
  // Order: lowest pitch first (125 Hz), rising to 8 kHz; 1 kHz is then repeated as a consistency check.
  var TEST_ORDER = [125, 250, 500, 1000, 2000, 4000, 8000];
  var FREQUENCIES = [125, 250, 500, 1000, 2000, 4000, 8000];   // sorted: used for the chart and the report
  var PTA_FREQS = [500, 1000, 2000, 4000];                 // standard "pure-tone average" frequencies
  var EARS = ['right', 'left'];
  // One "track" = finding the quietest beep heard at one pitch in one ear. After each ear's pitches,
  // 1 kHz is tested a second time (retest) as a consistency check.
  var TRACKS = [];
  EARS.forEach(function (ear) {
    TEST_ORDER.forEach(function (f) { TRACKS.push({ ear: ear, freq: f, retest: false }); });
    TRACKS.push({ ear: ear, freq: 1000, retest: true });
  });
  var TRACKS_PER_EAR = TEST_ORDER.length + 1;
  
  function freshState() {
    return {
      trackIndex: 0,
      track: null,
      results: [],       // { ear, freq, level (5-120), noResponse }
      retests: [],       // repeat 1 kHz per ear
      thr: { right: {}, left: {} },
      last: {},
      catchTotal: 0,     // silent "catch" trials shown
      falseAlarms: 0,    // taps during a silent catch trial
      spurious: 0,       // taps when no beep window was open
      sinceCatch: 0,
      unreliableTracks: 0,
      answers: {},
      earReady: false
    };
  }

  var state = freshState();
  state.audioCtx = null;
  state.oscillator = null;
  state.gainNode = null;
  state.panNode = null;
  state.setup = { headphones: null, channel: 'pending', channelTries: 0, noise: 'skipped' };

  var screens = {};
  root.querySelectorAll('.hs-audio__screen').forEach(function (el) {
    screens[el.getAttribute('data-screen')] = el;
  });

  // The 4-step indicator stays as is; the extra screens belong to a step:
  // setup -> "Test", questions -> "Details"
  var stepOrder = ['intro', 'test', 'contact', 'results'];
  var STEP_GROUP = { intro: 'intro', setup: 'test', test: 'test', questions: 'contact', contact: 'contact', results: 'results' };
  var stepItems = {};
  root.querySelectorAll('[data-step-item]').forEach(function (el) {
    stepItems[el.getAttribute('data-step-item')] = el;
  });

  function updateStepIndicator(name) {
    var group = STEP_GROUP[name] || name;
    var idx = stepOrder.indexOf(group);
    stepOrder.forEach(function (key, i) {
      var el = stepItems[key];
      if (!el) return;
      el.removeAttribute('data-current');
      el.removeAttribute('data-done');
      if (i === idx) el.setAttribute('data-current', 'true');
      else if (i < idx) el.setAttribute('data-done', 'true');
    });
    var announcer = root.querySelector('[data-step-announcer]');
    if (announcer && stepItems[group]) {
      announcer.textContent = 'Step ' + (idx + 1) + ' of ' + stepOrder.length + ': ' + stepItems[group].textContent.trim();
    }
  }

  // ---------- Analytics events (GA4 / Google Ads via gtag or GTM dataLayer, Meta Pixel, Shopify pixels) ----------
  // No names, emails or phone numbers are ever sent in these events. Switch off in the Theme Editor.
  var trackOn = root.getAttribute('data-track') !== 'false';
  var trackPrefix = root.getAttribute('data-track-prefix') || 'hearing_';
  var trackDebug = /[?&]hs_debug=1/.test(location.search);
  var currentStep = 'intro';
  var leadSent = false;
  var abandonSent = false;
  function track(name, params, standard) {
    if (!trackOn) return;
    var evt = standard ? name : trackPrefix + name;
    var p = Object.assign({ page_path: location.pathname }, params || {});
    try {
      if (typeof window.gtag === 'function') window.gtag('event', evt, p);
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: evt }, p)); }
    } catch (e) { /* analytics must never break the test */ }
    try {
      if (typeof window.fbq === 'function') {
        if (standard === 'Lead') window.fbq('track', 'Lead', p);
        else window.fbq('trackCustom', evt, p);
      }
    } catch (e) { /* no-op */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(evt, p);
    } catch (e) { /* no-op */ }
    if (trackDebug && window.console) console.log('[hearsilk analytics]', evt, p);
  }

  function showScreen(name) {
    Object.keys(screens).forEach(function (key) {
      screens[key].removeAttribute('data-active');
    });
    screens[name].setAttribute('data-active', 'true');
    currentStep = name;
    track('step', { step: name });
    updateStepIndicator(name);
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }

  // ---------- Analytics context (captured automatically, no customer input) ----------
  function classifyChannel(medium, hasGclid, hasFbclid) {
    var m = (medium || '').toLowerCase();
    var paidMediums = ['cpc', 'ppc', 'paid', 'paidsearch', 'paid-search', 'display', 'cpm', 'paid_social', 'paidsocial', 'retargeting'];
    if (hasGclid || hasFbclid) return 'Paid';
    if (paidMediums.indexOf(m) !== -1) return 'Paid';
    if (m === 'organic' || m === 'product_sync' || m === 'shopping_organic' || m === 'shopping') return 'Organic';
    if (m === 'email') return 'Email';
    if (m === 'social' || m === 'social_organic' || m === 'social-organic') return 'Social';
    if (m === 'referral') return 'Referral';
    return null; // unclear from medium alone \u2014 caller falls back to referrer-based logic
  }

  // The audiometer is usually reached from another page of the store, so the real source (ad / Google / ...)
  // is saved earlier by the tiny "hs_touch" snippet in theme.liquid. Used only when this visit has no source of its own.
  function readStoredTouch() {
    try {
      var t = JSON.parse(window.localStorage.getItem('hs_touch') || 'null');
      if (!t || !t.ts || (Date.now() - t.ts) > 30 * 86400000) return null;
      var sp = new URLSearchParams();
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (t[k]) sp.set(k, t[k]); });
      if (t.gclid) sp.set('gclid', '1');
      if (t.fbclid) sp.set('fbclid', '1');
      return { params: sp, referrer: t.referrer || '' };
    } catch (e) { return null; }
  }

  function detectTrafficSource() {
    var params = new URLSearchParams(window.location.search);
    var ref = document.referrer;
    var ownHost = window.location.hostname.replace(/^www\./, '');
    var refIsOwn = false;
    try { refIsOwn = !!ref && new URL(ref).hostname.replace(/^www\./, '') === ownHost; } catch (e) { /* ignore */ }
    if (!params.get('utm_source') && !params.get('utm_medium') && !params.get('gclid') && !params.get('fbclid') && (!ref || refIsOwn)) {
      var stored = readStoredTouch();
      if (stored) { params = stored.params; ref = stored.referrer; }
    }
    var utmSource = params.get('utm_source');
    var utmMedium = params.get('utm_medium');
    var utmCampaign = params.get('utm_campaign');
    var utmContent = params.get('utm_content');
    var utmTerm = params.get('utm_term');
    var hasGclid = !!params.get('gclid');
    var hasFbclid = !!params.get('fbclid');

    if (utmSource || utmMedium || hasGclid || hasFbclid) {
      var channel = classifyChannel(utmMedium, hasGclid, hasFbclid) || (utmSource ? 'Other' : 'Unknown');
      return {
        source: utmSource || (hasGclid ? 'google' : (hasFbclid ? 'facebook' : 'unknown')),
        medium: utmMedium || (hasGclid || hasFbclid ? 'paid' : 'unknown'),
        campaign: utmCampaign || null,
        content: utmContent || null,
        term: utmTerm || null,
        channel: channel
      };
    }

    if (!ref) return { source: 'direct', medium: 'none', campaign: null, content: null, term: null, channel: 'Direct' };
    try {
      var refHost = new URL(ref).hostname.replace(/^www\./, '');
      var thisHost = window.location.hostname.replace(/^www\./, '');
      if (refHost === thisHost) return { source: 'internal', medium: 'site', campaign: null, content: null, term: null, channel: 'Internal' };
      if (/google\./.test(refHost)) return { source: 'google', medium: 'organic', campaign: null, content: null, term: null, channel: 'Organic' };
      if (/bing\./.test(refHost)) return { source: 'bing', medium: 'organic', campaign: null, content: null, term: null, channel: 'Organic' };
      if (/facebook\.|instagram\./.test(refHost)) return { source: refHost, medium: 'social', campaign: null, content: null, term: null, channel: 'Social' };
      return { source: refHost, medium: 'referral', campaign: null, content: null, term: null, channel: 'Referral' };
    } catch (e) {
      return { source: 'unknown', medium: 'unknown', campaign: null, content: null, term: null, channel: 'Unknown' };
    }
  }

  function detectDeviceType() {
    var ua = navigator.userAgent || '';
    if (/tablet|ipad/i.test(ua)) return 'tablet';
    if (/mobile|android|iphone/i.test(ua)) return 'mobile';
    return 'desktop';
  }

  var analyticsContext = {
    trafficSource: detectTrafficSource(),
    deviceType: detectDeviceType(),
    landingPage: window.location.href,
    referrer: document.referrer || null,
    language: navigator.language || null,
    // The device's own time zone (a VPN does not change it)
    browserTimezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { return null; } })(),
    visitorId: (function () { try { var m = document.cookie.match(/(?:^|; )hs_vid=([^;]+)/); return m ? decodeURIComponent(m[1]).slice(0, 64) : null; } catch (e) { return null; } })(),
    platform: navigator.platform || null,
    viewport: window.innerWidth + 'x' + window.innerHeight,
    returningVisitor: (function () {
      try {
        var seen = window.localStorage.getItem('hs_audiometer_seen');
        window.localStorage.setItem('hs_audiometer_seen', '1');
        return !!seen;
      } catch (e) { return null; }
    })()
  };
  var testStartedAt = null;


  // ---------- Phone country picker (same as Quick Enquiry / Call Now) ----------
  var phoneCombo = root.querySelector('[data-aud-phone-combo]');
  var phoneTrigger = root.querySelector('[data-aud-phone-trigger]');
  var phoneTriggerFlag = root.querySelector('[data-aud-phone-flag]');
  var phoneTriggerCode = root.querySelector('[data-aud-phone-code]');
  var phoneDropdown = root.querySelector('[data-aud-phone-dropdown]');
  var phoneSearchInput = root.querySelector('[data-aud-phone-search]');
  var phoneList = root.querySelector('[data-aud-phone-list]');
  var phoneLocalInput = root.querySelector('[data-aud-phone-local]');
  var detectedDialCode = '1'; // fallback: US
  var currentCountryCode = 'US';
  var workerBase = (root.getAttribute('data-worker-endpoint') || '').replace(/\/+$/, '');

  // ---------- ISO2 → international dial code ----------
  var DIAL_CODES = {
    AF:"93",AL:"355",DZ:"213",AD:"376",AO:"244",AG:"1",AR:"54",AM:"374",AU:"61",AT:"43",
    AZ:"994",BS:"1",BH:"973",BD:"880",BB:"1",BY:"375",BE:"32",BZ:"501",BJ:"229",BT:"975",
    BO:"591",BA:"387",BW:"267",BR:"55",BN:"673",BG:"359",BF:"226",BI:"257",CV:"238",KH:"855",
    CM:"237",CA:"1",CF:"236",TD:"235",CL:"56",CN:"86",CO:"57",KM:"269",CG:"242",CR:"506",
    HR:"385",CU:"53",CY:"357",CZ:"420",DK:"45",DJ:"253",DM:"1",DO:"1",EC:"593",EG:"20",
    SV:"503",GQ:"240",ER:"291",EE:"372",SZ:"268",ET:"251",FJ:"679",FI:"358",FR:"33",GA:"241",
    GM:"220",GE:"995",DE:"49",GH:"233",GR:"30",GD:"1",GT:"502",GN:"224",GW:"245",GY:"592",
    HT:"509",HN:"504",HU:"36",IS:"354",IN:"91",ID:"62",IR:"98",IQ:"964",IE:"353",IL:"972",
    IT:"39",CI:"225",JM:"1",JP:"81",JO:"962",KZ:"7",KE:"254",KI:"686",XK:"383",KW:"965",
    KG:"996",LA:"856",LV:"371",LB:"961",LS:"266",LR:"231",LY:"218",LI:"423",LT:"370",LU:"352",
    MG:"261",MW:"265",MY:"60",MV:"960",ML:"223",MT:"356",MH:"692",MR:"222",MU:"230",MX:"52",
    FM:"691",MD:"373",MC:"377",MN:"976",ME:"382",MA:"212",MZ:"258",MM:"95",NA:"264",NR:"674",
    NP:"977",NL:"31",NZ:"64",NI:"505",NE:"227",NG:"234",KP:"850",MK:"389",NO:"47",OM:"968",
    PK:"92",PW:"680",PS:"970",PA:"507",PG:"675",PY:"595",PE:"51",PH:"63",PL:"48",PT:"351",
    QA:"974",RO:"40",RU:"7",RW:"250",KN:"1",LC:"1",VC:"1",WS:"685",SM:"378",ST:"239",
    SA:"966",SN:"221",RS:"381",SC:"248",SL:"232",SG:"65",SK:"421",SI:"386",SB:"677",SO:"252",
    ZA:"27",KR:"82",SS:"211",ES:"34",LK:"94",SD:"249",SR:"597",SE:"46",CH:"41",SY:"963",
    TW:"886",TJ:"992",TZ:"255",TH:"66",TL:"670",TG:"228",TO:"676",TT:"1",TN:"216",TR:"90",
    TM:"993",TV:"688",UG:"256",UA:"380",AE:"971",GB:"44",US:"1",UY:"598",UZ:"998",VU:"678",
    VA:"379",VE:"58",VN:"84",YE:"967",ZM:"260",ZW:"263"
  };

  // ---------- ISO2 → country name (same 196-country list) ----------
  var COUNTRY_NAMES = {
    AF:"Afghanistan",AL:"Albania",DZ:"Algeria",AD:"Andorra",AO:"Angola",AG:"Antigua and Barbuda",AR:"Argentina",AM:"Armenia",AU:"Australia",AT:"Austria",
    AZ:"Azerbaijan",BS:"Bahamas",BH:"Bahrain",BD:"Bangladesh",BB:"Barbados",BY:"Belarus",BE:"Belgium",BZ:"Belize",BJ:"Benin",BT:"Bhutan",
    BO:"Bolivia",BA:"Bosnia and Herzegovina",BW:"Botswana",BR:"Brazil",BN:"Brunei",BG:"Bulgaria",BF:"Burkina Faso",BI:"Burundi",CV:"Cabo Verde",KH:"Cambodia",
    CM:"Cameroon",CA:"Canada",CF:"Central African Republic",TD:"Chad",CL:"Chile",CN:"China",CO:"Colombia",KM:"Comoros",CG:"Congo (Congo-Brazzaville)",CR:"Costa Rica",
    HR:"Croatia",CU:"Cuba",CY:"Cyprus",CZ:"Czechia",DK:"Denmark",DJ:"Djibouti",DM:"Dominica",DO:"Dominican Republic",EC:"Ecuador",EG:"Egypt",
    SV:"El Salvador",GQ:"Equatorial Guinea",ER:"Eritrea",EE:"Estonia",SZ:"Eswatini",ET:"Ethiopia",FJ:"Fiji",FI:"Finland",FR:"France",GA:"Gabon",
    GM:"Gambia",GE:"Georgia",DE:"Germany",GH:"Ghana",GR:"Greece",GD:"Grenada",GT:"Guatemala",GN:"Guinea",GW:"Guinea-Bissau",GY:"Guyana",
    HT:"Haiti",HN:"Honduras",HU:"Hungary",IS:"Iceland",IN:"India",ID:"Indonesia",IR:"Iran",IQ:"Iraq",IE:"Ireland",IL:"Israel",
    IT:"Italy",CI:"Ivory Coast",JM:"Jamaica",JP:"Japan",JO:"Jordan",KZ:"Kazakhstan",KE:"Kenya",KI:"Kiribati",XK:"Kosovo",KW:"Kuwait",
    KG:"Kyrgyzstan",LA:"Laos",LV:"Latvia",LB:"Lebanon",LS:"Lesotho",LR:"Liberia",LY:"Libya",LI:"Liechtenstein",LT:"Lithuania",LU:"Luxembourg",
    MG:"Madagascar",MW:"Malawi",MY:"Malaysia",MV:"Maldives",ML:"Mali",MT:"Malta",MH:"Marshall Islands",MR:"Mauritania",MU:"Mauritius",MX:"Mexico",
    FM:"Micronesia",MD:"Moldova",MC:"Monaco",MN:"Mongolia",ME:"Montenegro",MA:"Morocco",MZ:"Mozambique",MM:"Myanmar",NA:"Namibia",NR:"Nauru",
    NP:"Nepal",NL:"Netherlands",NZ:"New Zealand",NI:"Nicaragua",NE:"Niger",NG:"Nigeria",KP:"North Korea",MK:"North Macedonia",NO:"Norway",OM:"Oman",
    PK:"Pakistan",PW:"Palau",PS:"Palestine",PA:"Panama",PG:"Papua New Guinea",PY:"Paraguay",PE:"Peru",PH:"Philippines",PL:"Poland",PT:"Portugal",
    QA:"Qatar",RO:"Romania",RU:"Russia",RW:"Rwanda",KN:"Saint Kitts and Nevis",LC:"Saint Lucia",VC:"Saint Vincent and the Grenadines",WS:"Samoa",SM:"San Marino",ST:"Sao Tome and Principe",
    SA:"Saudi Arabia",SN:"Senegal",RS:"Serbia",SC:"Seychelles",SL:"Sierra Leone",SG:"Singapore",SK:"Slovakia",SI:"Slovenia",SB:"Solomon Islands",SO:"Somalia",
    ZA:"South Africa",KR:"South Korea",SS:"South Sudan",ES:"Spain",LK:"Sri Lanka",SD:"Sudan",SR:"Suriname",SE:"Sweden",CH:"Switzerland",SY:"Syria",
    TW:"Taiwan",TJ:"Tajikistan",TZ:"Tanzania",TH:"Thailand",TL:"Timor-Leste",TG:"Togo",TO:"Tonga",TT:"Trinidad and Tobago",TN:"Tunisia",TR:"Turkey",
    TM:"Turkmenistan",TV:"Tuvalu",UG:"Uganda",UA:"Ukraine",AE:"United Arab Emirates",GB:"United Kingdom",US:"United States",UY:"Uruguay",UZ:"Uzbekistan",VU:"Vanuatu",
    VA:"Vatican City",VE:"Venezuela",VN:"Vietnam",YE:"Yemen",ZM:"Zambia",ZW:"Zimbabwe"
  };

  // dial codes shared by multiple countries — pick a sensible default
  var PRIMARY_FOR_DIAL = { "1": "US", "7": "RU" };

  function findCountryByDial(digitsOnly) {
    var maxLen = Math.min(4, digitsOnly.length);
    for (var len = maxLen; len >= 1; len--) {
      var candidate = digitsOnly.slice(0, len);
      if (PRIMARY_FOR_DIAL[candidate]) return { code: PRIMARY_FOR_DIAL[candidate], dial: candidate };
      for (var code in DIAL_CODES) {
        if (DIAL_CODES[code] === candidate) return { code: code, dial: candidate };
      }
    }
    return null;
  }

  // ---------- Phone country combo (custom dropdown with real flag icons) ----------
  function applyDialCode(countryCode) {
    var cc = (countryCode || 'US').toUpperCase();
    if (!DIAL_CODES[cc]) cc = 'US';
    currentCountryCode = cc;
    detectedDialCode = DIAL_CODES[cc];
    if (phoneTriggerFlag) {
      phoneTriggerFlag.className = 'fi fi-' + cc.toLowerCase() + ' hs-phone-trigger-flag';
    }
    if (phoneTriggerCode) phoneTriggerCode.textContent = '+' + detectedDialCode;
    if (phoneList) {
      phoneList.querySelectorAll('.hs-phone-dropdown-item').forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-code') === cc);
      });
    }
  }

  function buildPhoneList(filterText) {
    if (!phoneList) return;
    var q = (filterText || '').trim().toLowerCase();
    var codes = Object.keys(DIAL_CODES).sort(function (a, b) {
      return (COUNTRY_NAMES[a] || a).localeCompare(COUNTRY_NAMES[b] || b);
    });
    phoneList.innerHTML = '';
    var shown = 0;
    codes.forEach(function (code) {
      var name = COUNTRY_NAMES[code] || code;
      var dial = DIAL_CODES[code];
      if (q && name.toLowerCase().indexOf(q) === -1 && code.toLowerCase().indexOf(q) === -1 && dial.indexOf(q.replace('+', '')) === -1) return;
      shown++;
      var item = document.createElement('div');
      item.className = 'hs-phone-dropdown-item' + (code === currentCountryCode ? ' is-active' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('data-code', code);
      item.innerHTML =
        '<span class="fi fi-' + code.toLowerCase() + '"></span>' +
        '<span class="hs-phone-dropdown-name"></span>' +
        '<span class="hs-phone-dropdown-dial">+' + dial + '</span>';
      item.querySelector('.hs-phone-dropdown-name').textContent = name;
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        applyDialCode(code);
        closePhoneDropdown();
        if (phoneLocalInput) phoneLocalInput.focus();
      });
      phoneList.appendChild(item);
    });
    if (!shown) {
      phoneList.innerHTML = '<div class="hs-phone-dropdown-empty">No country found</div>';
    }
  }

  function openPhoneDropdown() {
    if (!phoneDropdown) return;
    buildPhoneList('');
    phoneDropdown.hidden = false;
    phoneTrigger.setAttribute('aria-expanded', 'true');
    if (phoneSearchInput) { phoneSearchInput.value = ''; setTimeout(function () { phoneSearchInput.focus(); }, 30); }
  }
  function closePhoneDropdown() {
    if (!phoneDropdown) return;
    phoneDropdown.hidden = true;
    phoneTrigger.setAttribute('aria-expanded', 'false');
  }
  if (phoneTrigger) {
    phoneTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (phoneDropdown.hidden) openPhoneDropdown(); else closePhoneDropdown();
    });
  }
  if (phoneSearchInput) {
    phoneSearchInput.addEventListener('input', function () { buildPhoneList(phoneSearchInput.value); });
  }
  document.addEventListener('click', function (e) {
    if (phoneCombo && !phoneCombo.contains(e.target)) closePhoneDropdown();
  });

  applyDialCode('US'); // default while geo-detecting
  if (workerBase) {
    fetch(workerBase + '/geo')
      .then(function (r) { return r.json(); })
      .then(function (d) { applyDialCode(d && d.country); })
      .catch(function () { /* keep default */ });
  }

  // ---------- Typing "+91 ..." or "0091 ..." directly auto-switches the country, and strips junk ----------
  if (phoneLocalInput) {
    phoneLocalInput.addEventListener('input', function () {
      if (phoneLocalInput._syncing) return;
      var val = phoneLocalInput.value;

      var prefixMatch = val.match(/^\s*(?:\+|00)(\d{1,4})/);
      if (prefixMatch) {
        var match = findCountryByDial(prefixMatch[1]);
        if (match) {
          applyDialCode(match.code);
          // strip exactly match.dial.length digits — not a greedy 4-digit guess
          var stripRe = new RegExp('^\\s*(?:\\+|00)\\d{' + match.dial.length + '}[\\s-]*');
          val = val.replace(stripRe, '');
        }
      }

      var cleaned = val.replace(/\D/g, '').slice(0, 12);
      phoneLocalInput._syncing = true;
      phoneLocalInput.value = cleaned;
      phoneLocalInput._syncing = false;
    });
  }

  // ---------- Web Audio ----------
  // Calibration. Level numbers are on a true decibel scale (every 5 on the scale = 5 dB of loudness), roughly in dB HL:
  // 0 is about the quietest sound a young normal ear can hear, and the number follows the sound from there.
  //  * ANCHOR: at 1 kHz, level L plays at (L - 74) dB below the loudest the device can do (dBFS), for a device at 100% volume.
  //  * COMP: ears are much less sensitive to low pitches (the same offsets real audiometers build in), and earphones
  //    deliver less bass, so low pitches are played louder by these dB amounts (relative to 1 kHz).
  //  * CAP: never louder than -3 dBFS (safety). Where the cap is reached, a pitch cannot be tested any higher (see reachLevel).
  // Theme Editor > Calibration lets you shift everything (or single pitches) if a known listener's result is off.
  var CAL = {
    anchor: 74,
    cap: 0.7,
    // tuned on one real audiogram (audiologist report vs. this test, wired earphones, 100% volume); Theme Editor trims add on top
    comp: { 125: 22, 250: 9.5, 500: 2.5, 1000: -7.5, 2000: -10, 4000: -5.5, 8000: -3 },
    offset: parseFloat(root.getAttribute('data-cal-offset') || '0') || 0,
    trim: {}
  };
  (root.getAttribute('data-cal-trim') || '').split(/[,\n;]+/).forEach(function (p) {
    var m = p.match(/(\d+)\s*[:=]\s*([+-]?\d+(?:\.\d+)?)/);
    if (m) CAL.trim[+m[1]] = parseFloat(m[2]);
  });
  var PRACTICE_LEVEL = 70;   // loud and clear for the practice beep and the left/right check
  function calDb(freq) { return -CAL.anchor + (CAL.comp[freq] || 0) + CAL.offset + (CAL.trim[freq] || 0); }
  function levelToGain(level, freq) {
    if (level <= 0) return 0;
    return Math.min(CAL.cap, Math.pow(10, (level + calDb(freq)) / 20));
  }
  // loudest level this pitch can be tested at on a normal device (multiple of 5)
  function reachLevel(freq) {
    var L = 20 * Math.log10(CAL.cap) - calDb(freq);
    return Math.max(25, Math.min(120, Math.floor(L / 5) * 5));
  }

  function ensureAudioGraph() {
    if (!state.audioCtx) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      state.audioCtx = new Ctx();
      state.oscillator = state.audioCtx.createOscillator();
      state.oscillator.type = 'sine';
      state.oscillator.frequency.value = 1000;
      state.gainNode = state.audioCtx.createGain();
      state.gainNode.gain.value = 0;
      state.panNode = state.audioCtx.createStereoPanner ? state.audioCtx.createStereoPanner() : null;
      state.oscillator.connect(state.gainNode);
      if (state.panNode) {
        state.gainNode.connect(state.panNode);
        state.panNode.connect(state.audioCtx.destination);
      } else {
        state.gainNode.connect(state.audioCtx.destination);
      }
      state.oscillator.start();
    }
    if (state.audioCtx.state === 'suspended' && state.audioCtx.resume) {
      try { var p = state.audioCtx.resume(); if (p && p.catch) p.catch(function () {}); } catch (e) { /* no-op */ }
    }
  }

  // Pulsed beeps (e.g. 3 x 220 ms) are easier to notice than one long tone, and make a clear "event" to react to.
  // Returns when the beeps start/how long they last, so the response window lines up with them.
  function playBeeps(freq, ear, level, pulses) {
    ensureAudioGraph();
    var c = state.audioCtx;
    var g = state.gainNode.gain;
    var amp = levelToGain(level, freq);
    var t0 = c.currentTime + 0.06;
    state.oscillator.frequency.setValueAtTime(freq, t0 - 0.03);
    if (state.panNode) state.panNode.pan.setValueAtTime(ear === 'right' ? 1 : -1, t0 - 0.03);
    g.cancelScheduledValues(c.currentTime);
    g.setValueAtTime(0, c.currentTime);
    for (var i = 0; i < pulses; i++) {
      var s = t0 + i * 0.35;
      g.setValueAtTime(0, s);
      g.linearRampToValueAtTime(amp, s + 0.03);
      g.setValueAtTime(amp, s + 0.19);
      g.linearRampToValueAtTime(0, s + 0.22);
    }
    return { startMs: performance.now() + 60, durMs: (pulses - 1) * 350 + 220 };
  }

  function silence() {
    if (!state.audioCtx) return;
    var g = state.gainNode.gain;
    g.cancelScheduledValues(state.audioCtx.currentTime);
    g.setValueAtTime(0, state.audioCtx.currentTime);
  }

  function teardownAudio() {
    if (!state.audioCtx) return;
    try {
      state.oscillator.stop();
      state.audioCtx.close();
    } catch (e) { /* no-op */ }
    state.audioCtx = null;
  }

  // ---------- Setup screen: headphones, left/right check, optional room-noise check ----------
  var setupUi = {
    chips: root.querySelectorAll('[data-hp]'),
    warn: root.querySelector('[data-setup-warn]'),
    playBtn: root.querySelector('[data-action="play-check"]'),
    answers: root.querySelector('[data-check-answers]'),
    checkMsg: root.querySelector('[data-check-msg]'),
    skipBtn: root.querySelector('[data-action="skip-check"]'),
    noiseBtn: root.querySelector('[data-action="noise-check"]'),
    noiseMsg: root.querySelector('[data-noise-msg]'),
    cont: root.querySelector('[data-action="setup-continue"]')
  };
  var checkSide = null;

  function updateSetupState() {
    var s = state.setup;
    var ready = !!s.headphones && (s.channel === 'pass' || s.channel === 'skipped');
    if (setupUi.cont) setupUi.cont.disabled = !ready;
    if (setupUi.warn) setupUi.warn.hidden = s.headphones !== 'speaker';
  }

  setupUi.chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      setupUi.chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); c.removeAttribute('data-selected'); });
      chip.setAttribute('aria-pressed', 'true');
      chip.setAttribute('data-selected', 'true');
      state.setup.headphones = chip.getAttribute('data-hp');
      updateSetupState();
    });
  });

  function setCheckMsg(text, tone) {
    if (!setupUi.checkMsg) return;
    setupUi.checkMsg.textContent = text || '';
    setupUi.checkMsg.setAttribute('data-tone', tone || '');
    setupUi.checkMsg.hidden = !text;
  }

  if (setupUi.playBtn) {
    setupUi.playBtn.addEventListener('click', function () {
      ensureAudioGraph();
      checkSide = Math.random() < 0.5 ? 'left' : 'right';
      state.setup.channelTries += 1;
      playBeeps(1000, checkSide, PRACTICE_LEVEL, 2);
      setCheckMsg('', '');
      setupUi.answers.hidden = false;
      setupUi.playBtn.textContent = root.getAttribute('data-txt-play-again') || 'Play again';
    });
  }
  root.querySelectorAll('[data-check-answer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var said = btn.getAttribute('data-check-answer');
      setupUi.answers.hidden = true;
      if (said === checkSide) {
        state.setup.channel = 'pass';
        setCheckMsg(root.getAttribute('data-txt-check-ok') || 'Great — the sound came from the correct side.', 'ok');
      } else {
        state.setup.channel = 'pending';
        setCheckMsg(root.getAttribute('data-txt-check-bad') || 'That did not match. Make sure the headphones are on the right way round (L on your left ear), then play again.', 'bad');
      }
      updateSetupState();
    });
  });
  if (setupUi.skipBtn) {
    setupUi.skipBtn.addEventListener('click', function () {
      if (state.setup.channel !== 'pass') state.setup.channel = 'skipped';
      setupUi.answers.hidden = true;
      setCheckMsg(root.getAttribute('data-txt-check-skip') || 'Check skipped — your result will be marked as less certain.', 'warn');
      updateSetupState();
    });
  }

  // Optional room-noise check: the microphone is only used to measure loudness for 2.5 seconds. Nothing is recorded or sent.
  function setNoiseMsg(text, tone) {
    if (!setupUi.noiseMsg) return;
    setupUi.noiseMsg.textContent = text;
    setupUi.noiseMsg.setAttribute('data-tone', tone || '');
    setupUi.noiseMsg.hidden = !text;
  }
  if (setupUi.noiseBtn) {
    setupUi.noiseBtn.addEventListener('click', function () {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        state.setup.noise = 'skipped';
        setNoiseMsg(T('noise_unsupported'), 'warn');
        return;
      }
      setupUi.noiseBtn.disabled = true;
      setNoiseMsg(T('noise_listening'), '');
      navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false } })
        .then(function (stream) {
          var AC = window.AudioContext || window.webkitAudioContext;
          var ac = new AC();
          var src = ac.createMediaStreamSource(stream);
          var an = ac.createAnalyser();
          an.fftSize = 2048;
          src.connect(an);
          var buf = new Float32Array(an.fftSize);
          var vals = [];
          var iv = setInterval(function () {
            if (!an.getFloatTimeDomainData) return;
            an.getFloatTimeDomainData(buf);
            var sum = 0;
            for (var i = 0; i < buf.length; i++) sum += buf[i] * buf[i];
            vals.push(20 * Math.log10(Math.sqrt(sum / buf.length) || 1e-6));
          }, 100);
          setTimeout(function () {
            clearInterval(iv);
            stream.getTracks().forEach(function (t) { t.stop(); });
            try { ac.close(); } catch (e) { /* no-op */ }
            setupUi.noiseBtn.disabled = false;
            if (!vals.length) { state.setup.noise = 'skipped'; setNoiseMsg(T('noise_failed'), 'warn'); return; }
            vals.sort(function (a, b) { return a - b; });
            var med = vals[Math.floor(vals.length / 2)];
            if (med < -52) { state.setup.noise = 'quiet'; setNoiseMsg(T('noise_quiet'), 'ok'); }
            else if (med < -42) { state.setup.noise = 'moderate'; setNoiseMsg(T('noise_moderate'), 'warn'); }
            else { state.setup.noise = 'noisy'; setNoiseMsg(T('noise_noisy'), 'bad'); }
          }, 2500);
        })
        .catch(function () {
          setupUi.noiseBtn.disabled = false;
          state.setup.noise = 'skipped';
          setNoiseMsg(T('noise_denied'), 'warn');
        });
    });
  }

  // ---------- Test screen ----------
  var ui = {
    earBadge: root.querySelector('[data-ear-badge]'),
    earLabel: root.querySelector('[data-ear-label]'),
    coreLabel: root.querySelector('[data-core-label]'),
    toneNum: root.querySelector('[data-tone-num]'),
    toneTotal: root.querySelector('[data-tone-total]'),
    progressBar: root.querySelector('[data-progress-bar]'),
    status: root.querySelector('[data-listen-status]'),
    heard: root.querySelector('[data-action="heard"]'),
    nohear: root.querySelector('[data-action="notheard"]'),
    beepNo: root.querySelector('[data-beep-no]'),
    pause: root.querySelector('[data-action="pause"]'),
    earBreak: root.querySelector('[data-ear-break]'),
    paused: root.querySelector('[data-paused-note]'),
    segs: root.querySelector('[data-tone-segs]'),
    journey: root.querySelector('[data-journey]'),
    meterVal: root.querySelector('[data-meter-val]'),
    meterFill: root.querySelector('[data-meter-fill]'),
    trail: root.querySelector('[data-trail]'),
    note: root.querySelector('[data-trial-note]'),
    phaseLabel: root.querySelector('[data-phase-label]'),
    toast: root.querySelector('[data-toast]'),
    freqHz: root.querySelector('[data-freq-hz]'),
    freqName: root.querySelector('[data-freq-name]'),
    earStep: root.querySelector('[data-ear-step]'),
    stage: root.querySelector('[data-stage]'),
    eq: root.querySelector('[data-eq]'),
    cd: root.querySelector('[data-countdown]'),
    cdSmall: root.querySelector('[data-cd-small]'),
    cdNum: root.querySelector('[data-cd-num]'),
    cdLine: root.querySelector('[data-cd-line]'),
    pBox: root.querySelector('[data-practice]'),
    pMsg: root.querySelector('[data-practice-msg]'),
    pPlay: root.querySelector('[data-action="practice-play"]'),
    pSkip: root.querySelector('[data-action="practice-skip"]')
  };
  if (ui.segs) for (var si = 0; si < TRACKS_PER_EAR; si++) ui.segs.appendChild(document.createElement('i'));
  // decorative sound-bars: always moving the same way, so they never reveal when a beep plays
  if (ui.eq) {
    for (var ei = 0; ei < 27; ei++) {
      var bar = document.createElement('i');
      bar.style.animationDelay = (-(ei * 0.37) % 2.2).toFixed(2) + 's';
      bar.style.animationDuration = (1.5 + (ei * 7 % 9) / 10).toFixed(2) + 's';
      ui.eq.appendChild(bar);
    }
    if (!flag('show-eq', true)) ui.eq.hidden = true;
  }
  root.setAttribute('data-booth', root.getAttribute('data-booth') || 'dark');
  // pitch journey: one chip per pitch (+ the repeat check) so the person sees how far along they are
  function freqShort(f) { return f >= 1000 ? (f / 1000) + 'k' : String(f); }
  if (ui.journey) {
    TEST_ORDER.forEach(function (f) {
      var c = document.createElement('span');
      c.className = 'hs-jchip';
      c.innerHTML = '<b>' + freqShort(f) + '</b><i></i>';
      ui.journey.appendChild(c);
    });
    var rc = document.createElement('span');
    rc.className = 'hs-jchip hs-jchip--re';
    rc.innerHTML = '<b>\u21BB</b><i></i>';
    ui.journey.appendChild(rc);
  }
  function setMeter(level) {
    if (ui.meterVal) ui.meterVal.textContent = level + ' dB';
    if (ui.meterFill) ui.meterFill.style.width = Math.max(3, Math.min(100, level / 100 * 100)) + '%';
  }
  function setNote(text, tone) {
    if (!ui.note) return;
    ui.note.textContent = text || '';
    ui.note.setAttribute('data-tone', tone || '');
    ui.note.removeAttribute('data-pop'); void ui.note.offsetWidth; if (text) ui.note.setAttribute('data-pop', 'true');
  }
  function addTrail(heard) {
    if (!ui.trail) return;
    var d = document.createElement('i');
    d.className = heard ? 'is-heard' : 'is-miss';
    ui.trail.appendChild(d);
  }
  var toastTimer = null;
  function showToast(text) {
    if (!ui.toast) return;
    ui.toast.textContent = text;
    ui.toast.setAttribute('data-show', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { ui.toast.removeAttribute('data-show'); }, 2000);
  }
  var timers = [];
  var practice = { active: false, tries: 0, skipped: false };
  var trial = null;     // the presentation that is currently open for a response
  var running = false;
  var paused = false;

  function later(fn, ms) { var id = setTimeout(fn, ms); timers.push(id); return id; }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }

  function round5(v) { return Math.round(v / 5) * 5; }
  function clampLevel(v, maxL) { return Math.max(5, Math.min(maxL || 120, round5(v))); }

  function setStatus(text) {
    if (ui.status) ui.status.querySelector('span').textContent = text;
  }

  function renderTestUI() {
    var def = state.track.def;
    var idxInEar = state.trackIndex % TRACKS_PER_EAR;
    ui.earLabel.textContent = def.ear === 'right' ? 'Right ear' : 'Left ear';
    ui.earBadge.textContent = def.ear === 'right' ? 'R' : 'L';
    if (ui.coreLabel) ui.coreLabel.textContent = ui.earLabel.textContent;
    root.setAttribute('data-test-ear', def.ear);
    if (ui.earStep) ui.earStep.textContent = T('ear_step', def.ear === 'right' ? 1 : 2);
    if (ui.freqHz) ui.freqHz.textContent = def.freq + ' Hz';
    if (ui.freqName) ui.freqName.textContent = def.retest ? T('pitch_retest') : (def.freq <= 500 ? T('pitch_low') : (def.freq <= 2000 ? T('pitch_mid') : T('pitch_high')));
    if (ui.trail) ui.trail.innerHTML = '';
    setNote('', '');
    root.setAttribute('data-pct', Math.round(state.trackIndex / TRACKS.length * 100));
    ui.toneNum.textContent = idxInEar + 1;
    ui.toneTotal.textContent = TRACKS_PER_EAR;
    ui.progressBar.style.width = (state.trackIndex / TRACKS.length * 100) + '%';
    if (ui.journey) {
      for (var j = 0; j < ui.journey.children.length; j++) {
        ui.journey.children[j].className = 'hs-jchip' + (j === TEST_ORDER.length ? ' hs-jchip--re' : '')
          + (j < idxInEar ? ' is-done' : (j === idxInEar ? ' is-current' : ''));
      }
    }
    if (ui.segs) {
      for (var i = 0; i < ui.segs.children.length; i++) {
        ui.segs.children[i].className = i < idxInEar ? 'is-done' : (i === idxInEar ? 'is-current' : '');
      }
    }
  }

  function startLevelFor(def) {
    var ref = null;
    if (def.retest) {
      if (state.thr[def.ear][1000] != null) ref = state.thr[def.ear][1000] - 10;   // + 20 below = first result + 10
    } else if (state.last[def.ear] != null) {
      ref = state.last[def.ear];
    } else if (state.thr.right[1000] != null) {
      ref = state.thr.right[1000];
    }
    var cap = reachLevel(def.freq);
    if (ref == null) return Math.min(40, cap);
    return Math.min(cap, Math.max(20, clampLevel(ref + 20, cap)));
  }

  function beginTrack(i, hold) {
    state.trackIndex = i;
    var def = TRACKS[i];
    state.track = { def: def, level: startLevelFor(def), phase: 'find', counts: {}, presentations: 0, missesAtMax: 0, maxL: reachLevel(def.freq) };
    renderTestUI();
    // switching to the left ear: ask the person to get ready first
    if (def.ear === 'left' && i === TRACKS_PER_EAR && !state.earReady) {
      ui.earBreak.hidden = false;
      setAnswerDisabled(true);
      setStatus('');
      return;
    }
    ui.earBreak.hidden = true;
    setAnswerDisabled(false);
    if (hold) return;
    nextPresentation();
  }

  // 3-2-1 countdown at the start of each ear (can be switched off in the Theme Editor)
  function startRound() {
    if (!flag('show-countdown', true) || !ui.cd) { nextPresentation(); return; }
    var earWord = T(state.track.def.ear === 'right' ? 'ear_right' : 'ear_left');
    setAnswerDisabled(true);
    ui.cd.hidden = false;
    ui.cdSmall.textContent = T('countdown_ready');
    ui.cdLine.textContent = T('countdown_go').replace('[ear]', earWord);
    var n = 3;
    (function tick() {
      ui.cdNum.textContent = n;
      ui.cdNum.setAttribute('data-n', n);
      ui.cdNum.style.animation = 'none'; void ui.cdNum.offsetWidth; ui.cdNum.style.animation = '';
      later(function () {
        n -= 1;
        if (n > 0) { tick(); return; }
        ui.cd.hidden = true;
        setAnswerDisabled(false);
        nextPresentation();
      }, 800);
    })();
  }

  // ---- One sound = one question. The beeps repeat until the person answers "I hear it" or "I can't hear it". ----
  var LOOP_MS = 1400;        // a new set of 3 beeps every 1.4 s, for as long as it takes
  var MIN_LISTEN_MS = 2400;  // "I can't hear it" opens after about two sets, so a very faint beep is not missed
  var NUDGE_AFTER = 10;      // gentle reminder after this many sets without an answer

  function setAnswerDisabled(off) {
    ui.heard.disabled = !!off;
    if (ui.nohear) ui.nohear.disabled = !!off;
  }
  function lockBtn(btn, on) {
    if (!btn) return;
    if (on) btn.setAttribute('data-locked', 'true'); else btn.removeAttribute('data-locked');
  }
  function statusFor(s) {
    if (s === 'wait') return T('status_wait');
    if (s === 'done') return T('tap_done');
    return root.getAttribute('data-txt-listening') || 'Listening…';
  }
  // Where we are in one question: wait -> listen (beeps repeating, answers open) -> done. Identical for real and silent trials.
  function setStep(s) {
    root.setAttribute('data-step', s);
    lockBtn(ui.heard, s !== 'listen');
    lockBtn(ui.nohear, true);   // opens a moment after the sound starts (see startTrial)
    setStatus(statusFor(s));
  }
  var hintTimer = null;
  function hint(text, btn) {
    setStatus(text);
    if (btn) btn.setAttribute('data-shake', 'true');
    clearTimeout(hintTimer);
    hintTimer = setTimeout(function () {
      if (btn) btn.removeAttribute('data-shake');
      if (running && !paused) setStatus(statusFor(root.getAttribute('data-step') || 'wait'));
    }, 1600);
  }

  function pulse() {
    var tr = trial;
    if (!tr || tr.answered || !running || paused) return;
    if (!tr.isCatch) playBeeps(tr.freq, tr.ear, tr.level, 3);   // a silent trial runs on exactly the same clock, just without sound
    tr.pulses += 1;
    tr.loopTimer = later(pulse, LOOP_MS);
    if (tr.pulses === NUDGE_AFTER) {
      if (tr.practice) showPracticeMsg(T('tap_nudge'), 'info'); else hint(T('tap_nudge'));
    }
  }

  function startTrial(spec) {
    var tr = { isCatch: !!spec.isCatch, practice: !!spec.practice, freq: spec.freq, ear: spec.ear, level: spec.level,
      answered: false, canNo: false, pulses: 0, startedAt: performance.now(), loopTimer: null };
    trial = tr;
    setStep('listen');
    later(function () {
      if (trial === tr && !tr.answered) { tr.canNo = true; lockBtn(ui.nohear, false); }
    }, MIN_LISTEN_MS);
    pulse();
  }

  function nextPresentation() {
    if (!running || paused) return;
    var t = state.track;
    state.sinceCatch += 1;
    state.soundNo = (state.soundNo || 0) + 1;
    if (ui.beepNo) ui.beepNo.textContent = T('beep_no', state.soundNo);
    // Silent "catch" trials: same screen, same timing, no sound. They show whether "I hear it" answers are real hearing or guessing.
    var isCatch = t.presentations > 0 && state.sinceCatch >= 5 && Math.random() < 0.15;
    if (isCatch) state.sinceCatch = 0;
    if (ui.phaseLabel) ui.phaseLabel.textContent = t.phase === 'find' ? T('phase_find') : T('phase_fine');
    setMeter(t.level);
    setStep('wait');
    later(function () {
      if (!running || paused) return;
      startTrial({ isCatch: isCatch, freq: t.def.freq, ear: t.def.ear, level: t.level });
    }, 450 + Math.random() * 350);
  }

  function flashHeard() {
    if (ui.stage) { ui.stage.setAttribute('data-tap', 'true'); setTimeout(function () { ui.stage.removeAttribute('data-tap'); }, 600); }
    if (ui.meterVal) { ui.meterVal.removeAttribute('data-tap'); void ui.meterVal.offsetWidth; ui.meterVal.setAttribute('data-tap', 'true'); }
    if (navigator.vibrate) { try { navigator.vibrate(25); } catch (e) { /* no-op */ } }
  }

  function onAnswer(heard) {
    if (!running || paused) return;
    var tr = trial;
    if (!tr || tr.answered) {
      if (!practice.active && root.getAttribute('data-step') === 'wait') hint(T('tap_early'), heard ? ui.heard : ui.nohear);
      return;
    }
    var now = performance.now();
    if (heard && now < tr.startedAt + 250) return;   // too soon to be an answer to the sound
    if (!heard && !tr.canNo) { hint(T('tap_wait'), ui.nohear); return; }
    tr.answered = true;
    tr.heard = heard;
    trial = null;
    clearTimeout(tr.loopTimer);
    silence();
    if (heard) flashHeard();
    if (tr.practice) { finishPractice(heard); return; }
    setStep('done');
    later(function () { finishTrial(tr); }, 500);
  }

  function finishTrial(tr) {
    if (tr.isCatch) {
      state.catchTotal += 1;
      if (tr.heard) state.falseAlarms += 1;
      nextPresentation();
      return;
    }
    var trk = state.track;
    addTrail(tr.heard);
    advanceTrack(tr.heard);
    if (state.track === trk) {
      var dir = trk.level < tr.level ? T('note_softer') : (trk.level > tr.level ? T('note_louder') : '');
      setNote((tr.heard ? T('note_heard', tr.level) : T('note_miss', tr.level).replace('[n]', tr.level)) + (dir ? ' — ' + dir : ''), tr.heard ? 'ok' : 'miss');
    }
  }

  // ---- Modified Hughson-Westlake staircase: find a level that is heard, go down 10, up 5; the threshold
  // is the quietest level that is heard twice. All levels are on the 5-120 scale used by this tool. ----
  function step(level) {
    state.track.level = clampLevel(level, state.track.maxL);
    nextPresentation();
  }

  function recordHeard(t, L) {
    t.counts[L] = (t.counts[L] || 0) + 1;
    if (t.counts[L] >= 2) return finishTrack(L, false, false);
    t.phase = 'down';   // after a response: drop 10, then climb in 5s again
    return step(L <= 5 ? 5 : L - 10);
  }

  function bestGuess(t) {
    var keys = Object.keys(t.counts).map(Number);
    if (keys.length) return Math.min.apply(null, keys);
    return t.level;
  }

  function advanceTrack(heard) {
    var t = state.track;
    t.presentations += 1;
    var L = t.level;
    if (t.presentations >= 24) return finishTrack(bestGuess(t), false, true);   // safety cap: never loop forever

    if (t.phase === 'find') {
      if (heard) { t.phase = 'down'; return step(L - 10); }
      if (L >= t.maxL) {
        t.missesAtMax += 1;
        if (t.missesAtMax >= 2) return finishTrack(120, true, false);
        return step(t.maxL);
      }
      return step(L + 10);
    }
    if (t.phase === 'down') {
      if (heard) {
        if (L <= 5) return recordHeard(t, L);
        return step(L - 10);
      }
      t.phase = 'up';
      return step(L + 5);
    }
    // phase 'up'
    if (heard) return recordHeard(t, L);
    if (L >= t.maxL) {
      t.missesAtMax += 1;
      if (t.missesAtMax >= 2) return finishTrack(120, true, false);
      return step(t.maxL);
    }
    return step(L + 5);
  }

  function finishTrack(level, noResponse, unreliable) {
    var def = state.track.def;
    var rec = { ear: def.ear, freq: def.freq, level: noResponse ? 120 : level, noResponse: !!noResponse, maxL: state.track.maxL, limited: !!noResponse && state.track.maxL < 70 };
    if (def.retest) {
      state.retests.push(rec);
    } else {
      state.results.push(rec);
      state.thr[def.ear][def.freq] = rec.level;
    }
    if (unreliable) state.unreliableTracks += 1;
    state.last[def.ear] = rec.level;
    if ((state.trackIndex + 1) % TRACKS_PER_EAR === 0) track('ear_done', { ear: def.ear });
    showToast(def.retest ? T('toast_retest') : (noResponse ? T('toast_nr').replace('[f]', def.freq) : T('toast_done', rec.level).replace('[f]', def.freq)));
    clearTimers();
    trial = null;
    var next = state.trackIndex + 1;
    if (next >= TRACKS.length) return finishTest();
    beginTrack(next);
  }

  function finishTest() {
    running = false;
    clearTimers();
    silence();
    teardownAudio();
    track('test_complete', { seconds: testStartedAt ? Math.round((Date.now() - testStartedAt) / 1000) : null });
    ui.progressBar.style.width = '100%';
    if (ui.phaseLabel) ui.phaseLabel.textContent = '';
    state.results.sort(function (a, b) {
      return (a.ear === b.ear ? 0 : (a.ear === 'right' ? -1 : 1)) || (a.freq - b.freq);
    });
    if (flag('show-questions', true)) { showScreen('questions'); }
    else { renderResults(); showScreen('contact'); }
  }

  // ---------- Practice round: one clearly audible beep, so the person learns what to do ----------
  function showPracticeMsg(text, tone) {
    ui.pMsg.textContent = text;
    ui.pMsg.setAttribute('data-tone', tone || '');
    ui.pMsg.hidden = !text;
  }
  function enterPractice() {
    practice.active = true;
    practice.tries = 0;
    practice.skipped = false;
    root.setAttribute('data-phase', 'practice');
    setMeter(PRACTICE_LEVEL);
    showPracticeMsg('', '');
    ui.pPlay.hidden = false;
    ui.pPlay.disabled = false;
    ui.pPlay.textContent = T('practice_button');
    ui.pSkip.hidden = true;
    setStep('wait');
  }
  function leavePractice() {
    practice.active = false;
    root.setAttribute('data-phase', 'test');
    state.spurious = 0;   // taps made while practising don't count against the person
  }
  function finishPractice(heard) {
    ui.pPlay.disabled = false;
    setStep('wait');
    if (heard) {
      showPracticeMsg(T('practice_ok'), 'ok');
      ui.pPlay.hidden = true;
      ui.pSkip.hidden = true;
      later(function () { leavePractice(); startRound(); }, 1800);
      return;
    }
    showPracticeMsg(T('practice_bad'), 'bad');
    ui.pPlay.textContent = T('practice_again');
    if (practice.tries >= 2) ui.pSkip.hidden = false;
  }
  if (ui.pPlay) {
    ui.pPlay.addEventListener('click', function () {
      if (!practice.active || trial) return;
      practice.tries += 1;
      ui.pPlay.disabled = true;
      setMeter(PRACTICE_LEVEL);
      showPracticeMsg(T('practice_listen'), 'info');
      startTrial({ practice: true, isCatch: false, freq: 1000, ear: 'right', level: PRACTICE_LEVEL });   // clearly audible, right ear, repeats until answered
    });
    ui.pSkip.addEventListener('click', function () {
      practice.skipped = true;
      leavePractice();
      startRound();
    });
  }

  function startTest() {
    var keep = { setup: state.setup, audioCtx: state.audioCtx, oscillator: state.oscillator, gainNode: state.gainNode, panNode: state.panNode };
    state = freshState();
    Object.keys(keep).forEach(function (k) { state[k] = keep[k]; });
    clearTimers();
    ensureAudioGraph();
    testStartedAt = Date.now();
    track('test_start', { headphones: state.setup.headphones || 'unknown', ear_check: state.setup.channel || 'unknown' });
    running = true;
    paused = false;
    root.setAttribute('data-run', 'on');
    ui.earBreak.hidden = true;
    ui.paused.hidden = true;
    ui.pause.textContent = root.getAttribute('data-txt-pause') || 'Pause';
    showScreen('test');
    beginTrack(0, true);
    if (flag('show-practice', true)) { enterPractice(); }
    else { leavePractice(); startRound(); }
    try { ui.heard.focus({ preventScroll: true }); } catch (e) { /* no-op */ }
  }

  function pauseTest() {
    if (!running || paused || practice.active) return;
    paused = true;
    root.setAttribute('data-run', 'paused');
    if (ui.cd) ui.cd.hidden = true;
    clearTimers();
    trial = null;
    silence();
    ui.paused.hidden = false;
    setAnswerDisabled(true);
    ui.pause.textContent = root.getAttribute('data-txt-resume') || 'Resume';
    setStatus('');
  }
  function resumeTest() {
    if (!running || !paused) return;
    paused = false;
    root.setAttribute('data-run', 'on');
    ui.paused.hidden = true;
    ui.pause.textContent = root.getAttribute('data-txt-pause') || 'Pause';
    if (!ui.earBreak.hidden) return;   // still waiting at the "switch ear" card
    setAnswerDisabled(false);
    ensureAudioGraph();
    nextPresentation();
  }

  function resetAll() {
    running = false;
    paused = false;
    root.setAttribute('data-run', 'off');
    if (ui.cd) ui.cd.hidden = true;
    clearTimers();
    trial = null;
    silence();
    teardownAudio();
    var setup = state.setup;
    state = freshState();
    state.audioCtx = null; state.oscillator = null; state.gainNode = null; state.panNode = null;
    state.setup = setup;
  }

  // If the person switches tab or gets a call mid-test, pause instead of silently failing tones
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && running && !paused) pauseTest();
  });

  // clicks worth measuring (consultation buttons, products, PDF, restart)
  root.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-action="consultation"], .hs-rec-card, [data-price-card-link], [data-action="download-pdf"], [data-action="retake"], [data-action="start-over"]') : null;
    if (!el) return;
    if (el.getAttribute('data-action') === 'consultation') {
      var where = el.closest('[data-redflag-banner]') ? 'banner' : (el.closest('.hs-consult') ? 'slider_strip' : 'summary');
      track('consult_click', { location: where, step: currentStep });
    } else if (el.classList.contains('hs-rec-card') || el.hasAttribute('data-price-card-link')) {
      var tEl = el.querySelector && el.querySelector('.hs-rec-card__title');
      var bEl = el.querySelector && el.querySelector('.hs-rec-card__brand');
      var mEl = el.querySelector && el.querySelector('.hs-rec-card__match');
      track('product_click', {
        product: tEl ? tEl.textContent : (root.querySelector('[data-price-card-title]') || {}).textContent || '',
        brand: bEl ? bEl.textContent : '', matched: mEl ? 'yes' : 'no', from: el.hasAttribute('data-price-card-link') ? 'top_pick' : 'slider'
      });
    } else if (el.getAttribute('data-action') === 'download-pdf') {
      track('pdf_download', {});
    } else {
      track(el.getAttribute('data-action') === 'retake' ? 'retake' : 'start_over', { step: currentStep });
    }
  });
  // left the page part-way through: record where
  function reportAbandon() {
    if (abandonSent || leadSent) return;
    if (['setup', 'test', 'questions', 'contact'].indexOf(currentStep) === -1) return;
    abandonSent = true;
    track('abandon', { step: currentStep, tone_index: state.trackIndex || 0, transport_type: 'beacon' });
  }
  window.addEventListener('pagehide', reportAbandon);

  // ---------- Wiring ----------
  root.querySelector('[data-action="start-test"]').addEventListener('click', function () {
    ensureAudioGraph();   // created on a tap, as browsers require
    showScreen('setup');
  });
  if (setupUi.cont) {
    setupUi.cont.addEventListener('click', function () {
      if (setupUi.cont.disabled) return;
      startTest();
    });
  }
  ui.heard.addEventListener('click', function () { onAnswer(true); });
  if (ui.nohear) ui.nohear.addEventListener('click', function () { onAnswer(false); });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'n' || e.key === 'N') && running && !paused && screens.test.hasAttribute('data-active')) {
      var tg2 = e.target && e.target.tagName;
      if (tg2 !== 'INPUT' && tg2 !== 'TEXTAREA' && tg2 !== 'SELECT') { onAnswer(false); return; }
    }
    if ((e.key === ' ' || e.code === 'Space') && running && !paused && screens.test.hasAttribute('data-active')) {
      var tg = e.target && e.target.tagName;
      if (tg === 'BUTTON' || tg === 'INPUT' || tg === 'TEXTAREA' || tg === 'SELECT' || tg === 'A') return;
      e.preventDefault();
      onAnswer(true);
    }
  });
  ui.pause.addEventListener('click', function () { if (paused) resumeTest(); else pauseTest(); });
  // Back to the start (or straight to the setup screen when retaking). Setup choices are cleared on purpose:
  // a retake should re-check headphones and volume.
  function startOver(target) {
    resetAll();
    practice.active = false; practice.skipped = false; practice.tries = 0;
    root.setAttribute('data-phase', 'test');
    state.setup = { headphones: null, channel: 'pending', channelTries: 0, noise: 'skipped' };
    setupUi.chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); c.removeAttribute('data-selected'); });
    setCheckMsg('', ''); setNoiseMsg('', '');
    if (setupUi.answers) setupUi.answers.hidden = true;
    if (setupUi.playBtn) setupUi.playBtn.textContent = root.getAttribute('data-txt-play') || 'Play a sound';
    root.querySelectorAll('[data-q] [data-val]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.removeAttribute('data-selected'); });
    root.querySelectorAll('[data-q-warn]').forEach(function (w) { w.setAttribute('data-on', 'false'); });
    if (qNext) qNext.disabled = true;
    updateSetupState();
    if (target === 'setup') ensureAudioGraph();
    showScreen(target || 'intro');
  }
  root.querySelector('[data-action="start-over"]').addEventListener('click', function () { startOver('intro'); });
  root.querySelector('[data-action="continue-ear"]').addEventListener('click', function () {
    state.earReady = true;
    ensureAudioGraph();
    beginTrack(state.trackIndex, true);
    startRound();
    try { ui.heard.focus({ preventScroll: true }); } catch (e) { /* no-op */ }
  });
  updateSetupState();

  // ---------- Quick questions ----------
  var qNext = root.querySelector('[data-action="questions-next"]');
  var QUESTION_KEYS = ['noisy', 'tinnitus', 'sudden'];
  root.querySelectorAll('[data-q]').forEach(function (group) {
    var key = group.getAttribute('data-q');
    group.querySelectorAll('[data-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-val]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.removeAttribute('data-selected'); });
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('data-selected', 'true');
        state.answers[key] = btn.getAttribute('data-val');
        var warn = group.querySelector('[data-q-warn]');
        if (warn) warn.setAttribute('data-on', state.answers[key] === 'yes' ? 'true' : 'false');
        qNext.disabled = !QUESTION_KEYS.every(function (k) { return !!state.answers[k]; });
      });
    });
  });
  qNext.addEventListener('click', function () {
    if (qNext.disabled) return;
    renderResults();
    showScreen('contact');
  });

  // ---------- Scoring ----------
  function txt(attr, fallback) { return root.getAttribute(attr) || fallback; }

  function r5(v) { return Math.round(v / 5) * 5; }

  function categorize(level) {
    if (level <= 25) return { label: 'Normal', tone: 'good' };
    if (level <= 40) return { label: 'Mild loss', tone: 'mild' };
    if (level <= 70) return { label: 'Moderate loss', tone: 'moderate' };
    if (level <= 90) return { label: 'Severe loss', tone: 'severe' };
    return { label: 'Profound / No response', tone: 'profound' };
  }

  // Pure-tone average over 500 / 1000 / 2000 / 4000 Hz: the standard single number audiologists classify by.
  function earPta(ear) {
    var vals = state.results.filter(function (r) { return r.ear === ear && PTA_FREQS.indexOf(r.freq) !== -1; })
      .map(function (r) { return r.level; });
    if (!vals.length) return 0;
    return vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
  }

  var MEANING = {
    good: 'Soft sounds are heard well.',
    mild: 'Soft sounds and speech in noise can be missed.',
    moderate: 'Conversation can be hard to follow, especially in groups.',
    severe: 'Most speech is hard to hear without amplification.',
    profound: 'Even loud sounds are difficult to hear.'
  };

  function buildRecommendation(rightCat, leftCat) {
    var worst = [rightCat, leftCat].sort(function (a, b) {
      return ['Normal', 'Mild loss', 'Moderate loss', 'Severe loss', 'Profound / No response'].indexOf(b.label)
        - ['Normal', 'Mild loss', 'Moderate loss', 'Severe loss', 'Profound / No response'].indexOf(a.label);
    })[0];

    var attrMap = {
      good: 'data-rec-good',
      mild: 'data-rec-mild',
      moderate: 'data-rec-moderate',
      severe: 'data-rec-severe',
      profound: 'data-rec-profound'
    };
    var text = root.getAttribute(attrMap[worst.tone] || attrMap.profound);
    return text || '';
  }

  // ---------- How much can this result be trusted? (confidence) ----------
  function computeQuality() {
    var reasons = [];
    var score = 100;
    var cap = 'high';
    var s = state.setup;
    function bad(pen, text) { score -= pen; reasons.push({ ok: false, text: text }); }
    function good(text) { reasons.push({ ok: true, text: text }); }

    if (s.headphones === 'speaker') { bad(45, T('reason_speaker')); cap = 'low'; }
    else if (s.headphones === 'bluetooth') bad(10, T('reason_bluetooth'));
    else if (s.headphones) good(T('reason_wired'));

    if (s.channel === 'pass') good(T('reason_check_ok'));
    else { bad(20, T('reason_check_skipped')); if (cap === 'high') cap = 'medium'; }

    if (s.noise === 'quiet') good(T('reason_noise_quiet'));
    else if (s.noise === 'moderate') bad(10, T('reason_noise_moderate'));
    else if (s.noise === 'noisy') bad(30, T('reason_noise_noisy'));

    // Consistency: 1 kHz was measured twice in each ear
    var retest = {};
    var maxDiff = 0;
    EARS.forEach(function (ear) {
      var rt = state.retests.filter(function (r) { return r.ear === ear; })[0];
      var first = state.thr[ear][1000];
      if (rt && first != null) {
        var d = Math.abs(rt.level - first);
        retest[ear] = { first: first, second: rt.level, diff: d };
        if (d > maxDiff) maxDiff = d;
      }
    });
    if (Object.keys(retest).length) {
      if (maxDiff <= 5) good(T('reason_retest_match'));
      else if (maxDiff <= 10) { /* normal variation: no comment */ }
      else if (maxDiff <= 15) bad(20, T('reason_retest_diff', maxDiff));
      else bad(35, T('reason_retest_bad', maxDiff));
    }

    // Silent catch trials: taps when nothing played
    var faRate = state.catchTotal ? state.falseAlarms / state.catchTotal : 0;
    if (state.catchTotal >= 3 && faRate >= 0.5) { bad(35, T('reason_fa_high')); cap = 'low'; }
    else if (state.catchTotal >= 3 && faRate >= 0.25) bad(15, T('reason_fa_some'));
    if (state.spurious >= 5) bad(10, T('reason_stray'));

    var nrCount = state.results.filter(function (r) { return r.noResponse && !r.limited; }).length;
    if (nrCount >= 6) bad(25, T('reason_nr_many'));
    if (state.unreliableTracks > 0) bad(10, T('reason_unreliable'));

    if (practice.skipped) bad(10, T('reason_practice'));
    score = Math.max(0, score);
    var level = score >= 75 ? 'high' : (score >= 50 ? 'medium' : 'low');
    var order = ['low', 'medium', 'high'];
    if (order.indexOf(cap) < order.indexOf(level)) level = cap;
    return { level: level, score: score, reasons: reasons, retest: retest, nrCount: nrCount };
  }

  // ---------- Audiogram (SVG) ----------
  var AXIS_FREQUENCIES = [125, 250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];
  var BANDS = [
    { from: 0, to: 25, fill: '#E6F4EE', label: 'Normal' },
    { from: 25, to: 40, fill: '#F2F3DE', label: 'Mild' },
    { from: 40, to: 70, fill: '#FBEFD9', label: 'Moderate' },
    { from: 70, to: 90, fill: '#F9E0D6', label: 'Severe' },
    { from: 90, to: 120, fill: '#F4D2CA', label: 'Profound' }
  ];

  // Table: the level found at every pitch, in steps of 5 dB
  function renderLevels() {
    var box = root.querySelector('[data-levels]');
    if (!box) return;
    function cell(ear, f) {
      var r = state.results.filter(function (x) { return x.ear === ear && x.freq === f; })[0];
      if (!r) return '<td>\u2013</td>';
      var lvl = r5(r.level);
      var tone = r.limited ? 'na' : categorize(lvl).tone;
      return '<td data-tone="' + tone + '">' + (r.noResponse ? '&gt;' + (r.maxL || 120) : lvl) + '<small> dB</small></td>';
    }
    var rows = FREQUENCIES.map(function (f) {
      return '<tr><th scope="row">' + f + ' Hz</th>' + cell('right', f) + cell('left', f) + '</tr>';
    }).join('');
    box.innerHTML = '<p class="hs-levels__title">' + T('lv_title') + '</p><table><thead><tr><th>' + T('lv_pitch')
      + '</th><th><i class="hs-dot hs-dot--right"></i>' + T('lv_right') + '</th><th><i class="hs-dot hs-dot--left"></i>'
      + T('lv_left') + '</th></tr></thead><tbody>' + rows + '</tbody></table>';
    var over = state.results.filter(function (r) { return r.noResponse && !r.limited; });
    if (over.length) {
      var top = Math.max.apply(null, over.map(function (r) { return r.maxL || 120; }));
      box.innerHTML += '<p class="hs-limit-note">' + T('limit_note').replace('[n]', top) + '</p>';
    }
  }

  function renderAudiogram() {
    var svg = root.querySelector('[data-audiogram]');
    var W = 560, H = 372, padL = 66, padR = 24, padT = 34, padB = 44;
    var plotW = W - padL - padR, plotH = H - padT - padB;

    function xFor(freq) {
      var minLog = Math.log10(AXIS_FREQUENCIES[0]);
      var maxLog = Math.log10(AXIS_FREQUENCIES[AXIS_FREQUENCIES.length - 1]);
      return padL + ((Math.log10(freq) - minLog) / (maxLog - minLog)) * plotW;
    }
    function yFor(level) {
      return padT + (level / 120) * plotH;
    }

    var svgParts = [];
    svgParts.push('<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="none"/>');

    // Shaded bands: where the line sits tells the story at a glance
    BANDS.forEach(function (b) {
      svgParts.push('<rect x="' + padL + '" y="' + yFor(b.from) + '" width="' + plotW + '" height="' + (yFor(b.to) - yFor(b.from)) + '" fill="' + b.fill + '"/>');
      svgParts.push('<text x="' + (W - padR - 6) + '" y="' + (yFor((b.from + b.to) / 2) + 3) + '" font-size="8.5" fill="#6C807D" text-anchor="end" font-family="IBM Plex Mono, monospace">' + b.label + '</text>');
    });

    // "Everyday speech" zone: where the sounds of conversation usually sit
    var speech = [[250, 45], [500, 35], [1000, 28], [2000, 25], [4000, 30], [6000, 42], [4000, 55], [2000, 58], [1000, 60], [500, 62]];
    svgParts.push('<path d="' + speech.map(function (p, i) { return (i ? 'L' : 'M') + xFor(p[0]).toFixed(1) + ' ' + yFor(p[1]).toFixed(1); }).join(' ')
      + ' Z" fill="rgba(14,110,100,.10)" stroke="#0E6E64" stroke-opacity=".35" stroke-dasharray="4,3" stroke-linejoin="round"/>');
    svgParts.push('<text x="' + xFor(1000) + '" y="' + (yFor(44) + 3) + '" font-size="8.5" fill="#0A4F48" text-anchor="middle" font-family="IBM Plex Mono, monospace" opacity=".8">' + T('speech_label') + '</text>');

    // Axis titles
    svgParts.push('<text x="' + (padL + plotW / 2) + '" y="14" font-size="10" font-weight="600" fill="#4C6764" text-anchor="middle" font-family="IBM Plex Mono, monospace">PITCH (Hz)</text>');
    svgParts.push('<text x="16" y="' + (padT + plotH / 2) + '" font-size="10" font-weight="600" fill="#4C6764" text-anchor="middle" font-family="IBM Plex Mono, monospace" transform="rotate(-90 16 ' + (padT + plotH / 2) + ')">ESTIMATED LEVEL (dB)</text>');

    // Horizontal gridlines every 5 units, 0-120
    for (var lvl = 0; lvl <= 120; lvl += 5) {
      var y = yFor(lvl);
      var major = (lvl % 20 === 0);
      svgParts.push('<line x1="' + padL + '" y1="' + y + '" x2="' + (W - padR) + '" y2="' + y + '" stroke="' + (major ? '#C9DCD6' : '#E3EEEA') + '" stroke-width="1"/>');
      if (major) svgParts.push('<text x="' + (padL - 8) + '" y="' + (y + 3) + '" font-size="8.5" fill="#4C6764" text-anchor="end" font-family="IBM Plex Mono, monospace">' + lvl + '</text>');
    }
    // Vertical gridlines for the full clinical frequency range — solid at tested pitches, dotted at reference-only points
    AXIS_FREQUENCIES.forEach(function (f) {
      var x = xFor(f);
      var isTested = FREQUENCIES.indexOf(f) !== -1;
      svgParts.push('<line x1="' + x + '" y1="' + padT + '" x2="' + x + '" y2="' + (H - padB) + '" stroke="' + (isTested ? '#C9DCD6' : '#E3EEEA') + '" stroke-width="1" stroke-dasharray="' + (isTested ? 'none' : '2,3') + '"/>');
      svgParts.push('<text x="' + x + '" y="' + (H - padB + 18) + '" font-size="' + (isTested ? '9.5' : '8') + '" font-weight="' + (isTested ? '600' : '400') + '" fill="#4C6764" text-anchor="middle" font-family="IBM Plex Mono, monospace">' + f + '</text>');
    });

    ['right', 'left'].forEach(function (ear) {
      var cs = window.getComputedStyle(root);
      var color = ear === 'right' ? (cs.getPropertyValue('--hs-coral').trim() || '#D6482C') : (cs.getPropertyValue('--hs-teal').trim() || '#0E6E64');
      var pts = [];
      FREQUENCIES.forEach(function (f) {
        var r = state.results.find(function (res) { return res.ear === ear && res.freq === f; });
        if (r) pts.push({ x: xFor(f), y: yFor(r.noResponse ? (r.maxL || 120) : r.level), nr: r.noResponse });
      });
      var path = pts.map(function (p, i) { return (i === 0 ? 'M' : 'L') + p.x + ' ' + p.y; }).join(' ');
      svgParts.push('<path d="' + path + '" fill="none" stroke="' + color + '" stroke-width="2"/>');
      pts.forEach(function (p) {
        if (ear === 'right') {
          svgParts.push('<circle cx="' + p.x + '" cy="' + p.y + '" r="5" fill="#fff" stroke="' + color + '" stroke-width="2"/>');
        } else {
          svgParts.push('<path d="M' + (p.x - 5) + ' ' + (p.y - 5) + ' L' + (p.x + 5) + ' ' + (p.y + 5) + ' M' + (p.x - 5) + ' ' + (p.y + 5) + ' L' + (p.x + 5) + ' ' + (p.y - 5) + '" stroke="' + color + '" stroke-width="2"/>');
        }
        if (p.nr) svgParts.push('<path d="M' + p.x + ' ' + (p.y + 8) + ' v8 m-3 -3 l3 3 l3 -3" fill="none" stroke="' + color + '" stroke-width="1.6"/>');
      });
    });

    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.innerHTML = svgParts.join('');
  }

  var lastScoring = null;

  function absoluteUrl(u) { try { return new URL(u, location.origin).href; } catch (e) { return ''; } }
  function viewAllUrlFor(tone) {
    var map = {
      good: root.getAttribute('data-url-general'),
      mild: root.getAttribute('data-url-mild'),
      moderate: root.getAttribute('data-url-moderate'),
      severe: root.getAttribute('data-url-severe'),
      profound: root.getAttribute('data-url-profound')
    };
    return map[tone] || root.getAttribute('data-url-general') || '/collections/hearing-aids';
  }

  // ---------- Product recommendations (live, by tag) ----------
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function fetchFeedProducts(limit, cb) {
    fetch('/collections/all/products.json?limit=' + limit, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cb(((d && d.products) || []).map(function (p) {
          var v = (p.variants && p.variants[0]) || {};
          return {
            vendor: String(p.vendor || ''),
            title: String(p.title || ''),
            url: '/products/' + p.handle,
            price: Math.round(parseFloat(String(v.price || '0')) * 100),
            compare: Math.round(parseFloat(String(v.compare_at_price || '0')) * 100),
            img: (p.images && p.images[0] && p.images[0].src) ? (p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2')) : ''
          };
        }));
      })
      .catch(function () { cb([]); });
  }

  function fetchProductsByTag(tag, limit, cb, fields) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(tag)
      + '&resources[type]=product&resources[limit]=' + limit
      + '&resources[options][fields]=' + (fields || 'tag')
      + '&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var raw = (d.resources && d.resources.results && d.resources.results.products) || [];
        var results = raw.map(function (p) {
          return {
            vendor: String(p.vendor || ''),
            title: String(p.title || ''),
            url: p.url || ('/products/' + (p.handle || '')),
            price: Math.round(parseFloat(String(p.price || p.price_min || '0')) * 100),
            compare: Math.round(parseFloat(String(p.compare_at_price || p.compare_at_price_min || '0')) * 100),
            img: (p.featured_image && p.featured_image.url) ? (p.featured_image.url + '&width=300') : (p.image || '')
          };
        });
        cb(results);
      })
      .catch(function (err) {
        console.error('HearSilk product recommendation fetch error:', err);
        cb([]);
      });
  }

  function renderProductCards(products) {
    var grid = root.querySelector('[data-recs-grid]');
    if (!products.length) {
      grid.innerHTML = '<div class="hs-recs__empty">' + T('rec_empty') + '</div>';
      return;
    }
    grid.innerHTML = products.map(function (p) {
      var savePct = (p.compare > p.price && p.compare > 0) ? Math.round((p.compare - p.price) * 100 / p.compare) : 0;
      return '<a class="hs-rec-card" href="' + p.url + '">'
        + (p.img ? '<img class="hs-rec-card__img" src="' + p.img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '<div class="hs-rec-card__img"></div>')
        + '<div class="hs-rec-card__body">'
        + (p.match ? '<span class="hs-rec-card__match">' + T('rec_match') + '</span>' : '')
        + (p.vendor ? '<div class="hs-rec-card__brand">' + p.vendor.replace(/</g, '&lt;') + '</div>' : '')
        + '<div class="hs-rec-card__title">' + p.title.replace(/</g, '&lt;') + '</div>'
        + '<div class="hs-rec-card__price-row">'
        + '<span class="hs-rec-card__price">' + formatMoney(p.price) + '</span>'
        + (p.compare > p.price ? '<span class="hs-rec-card__compare">' + formatMoney(p.compare) + '</span>' : '')
        + '</div>'
        + (savePct > 0 ? '<span class="hs-rec-card__save">Save ' + savePct + '%</span>' : '')
        + '</div></a>';
    }).join('');
    updateRail();
  }

  // ---------- Product slider (one rail for every brand) ----------
  var rail = root.querySelector('[data-recs-grid]');
  var railPrev = root.querySelector('[data-rail-prev]');
  var railNext = root.querySelector('[data-rail-next]');
  var railBar = root.querySelector('[data-rail-bar]');
  function updateRail() {
    if (!rail) return;
    var max = rail.scrollWidth - rail.clientWidth;
    if (railPrev) railPrev.disabled = rail.scrollLeft <= 2;
    if (railNext) railNext.disabled = rail.scrollLeft >= max - 2;
    if (railBar) railBar.style.width = (max > 0 ? Math.max(12, rail.clientWidth / rail.scrollWidth * 100) : 100) + '%';
    if (railBar) railBar.style.marginLeft = (max > 0 ? (rail.scrollLeft / rail.scrollWidth * 100) : 0) + '%';
  }
  function railStep(dir) { rail.scrollBy({ left: dir * Math.max(240, rail.clientWidth * 0.8), behavior: 'smooth' }); }
  if (rail) {
    rail.addEventListener('scroll', updateRail, { passive: true });
    window.addEventListener('resize', updateRail);
    if (railPrev) railPrev.addEventListener('click', function () { railStep(-1); });
    if (railNext) railNext.addEventListener('click', function () { railStep(1); });
  }

  var currentGridProducts = [];

  // Best match order: products tagged for the person's loss level first (then the rest), inside each group the
  // brands are taken in turns (round-robin) and every brand's own list runs from the highest price down.
  function mixBrands(list) {
    function mix(items) {
      var byBrand = {}, order = [];
      items.forEach(function (p) {
        var b = (p.vendor || '').toLowerCase() || '_';
        if (!byBrand[b]) { byBrand[b] = []; order.push(b); }
        byBrand[b].push(p);
      });
      order.forEach(function (b) { byBrand[b].sort(function (x, y) { return y.price - x.price; }); });
      order.sort(function (x, y) { return byBrand[y][0].price - byBrand[x][0].price; });   // brand with the top-priced model leads
      var out = [], more = true, i = 0;
      while (more) {
        more = false;
        order.forEach(function (b) { if (byBrand[b][i]) { out.push(byBrand[b][i]); more = true; } });
        i += 1;
      }
      return out;
    }
    return mix(list.filter(function (p) { return p.match; })).concat(mix(list.filter(function (p) { return !p.match; })));
  }

  function applySortAndRender() {
    var sortValue = root.querySelector('[data-recs-sort]').value;
    var sorted = currentGridProducts.slice();
    if (sortValue === 'price-asc') sorted.sort(function (a, b) { return a.price - b.price; });
    else if (sortValue === 'price-desc') sorted.sort(function (a, b) { return b.price - a.price; });
    else sorted = mixBrands(sorted);   // best match: your loss level first, highest price first, all brands mixed
    renderProductCards(sorted);
    if (rail) rail.scrollLeft = 0;
  }

  root.querySelector('[data-recs-sort]').addEventListener('change', applySortAndRender);

  function renderPriceCard(product) {
    var card = root.querySelector('[data-price-card]');
    if (!product || !product.price) { card.hidden = true; return; }

    var clinicMultiplier = parseFloat(root.getAttribute('data-clinic-multiplier') || '35') / 10;
    var clinicPrice = Math.round(product.price * clinicMultiplier);
    var hasRetail = product.compare > product.price;

    var priceCardImg = card.querySelector('[data-price-card-img]');
    priceCardImg.src = product.img || '';
    priceCardImg.alt = product.title || 'Recommended hearing aid';
    card.querySelector('[data-price-card-title]').textContent = product.title;
    card.querySelector('[data-price-clinic]').textContent = formatMoney(clinicPrice);
    card.querySelector('[data-price-you]').textContent = formatMoney(product.price);
    card.querySelector('[data-price-card-link]').href = product.url;

    var retailRow = card.querySelector('[data-price-row-retail]');
    if (hasRetail) {
      retailRow.hidden = false;
      card.querySelector('[data-price-retail]').textContent = formatMoney(product.compare);
    } else {
      retailRow.hidden = true;
    }

    var bestSave = clinicPrice - product.price;
    var bestBase = clinicPrice;
    var bestLabel = 'vs. audiologist clinic';
    if (hasRetail && (product.compare - product.price) > bestSave) {
      bestSave = product.compare - product.price;
      bestBase = product.compare;
      bestLabel = 'vs. retail price';
    }
    var saveBanner = card.querySelector('[data-save-banner]');
    if (bestSave > 0) {
      var pct = Math.round((bestSave / bestBase) * 100);
      saveBanner.textContent = 'You save ' + formatMoney(bestSave) + ' (' + pct + '%) ' + bestLabel;
    } else {
      saveBanner.textContent = '';
    }

    card.hidden = false;
  }

  function loadRecommendations(worstTone) {
    var section = root.querySelector('[data-recommend-section], .hs-recs');
    var viewAllLink = root.querySelector('[data-view-all-link]');
    var viewAllUrl = viewAllUrlFor(worstTone);
    if (viewAllLink) viewAllLink.href = viewAllUrl;
    if (section) section.hidden = false;

    if (worstTone === 'good') {
      renderPriceCard(null);
      currentGridProducts = [];
      root.querySelector('[data-recs-grid]').innerHTML =
        '<div class="hs-recs__empty">Your results look normal \u2014 explore our full range if you\u2019d still like to browse.</div>';
      return;
    }

    var subEl = root.querySelector('[data-recs-sub]');
    var lossLabel = { mild: 'mild loss', moderate: 'moderate loss', severe: 'severe loss', profound: 'significant loss' }[worstTone] || 'result';
    if (subEl) subEl.textContent = T('rec_sub').replace('[loss]', lossLabel);
    var tag = 'hearing-' + worstTone;
    var brands = (root.getAttribute('data-brands') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var perBrand = Math.max(2, Math.min(6, Math.round(parseInt(root.getAttribute('data-recs-count') || '6', 10) / 2)));
    var jobs = 1 + brands.length * 2;
    var pool = [];
    var matchedUrls = {};
    function done() {
      jobs -= 1;
      if (jobs > 0) return;
      var seen = {};
      var all = [];
      pool.forEach(function (p) {
        if (!p.url || seen[p.url] || !p.price) return;
        seen[p.url] = true;
        p.match = !!matchedUrls[p.url];
        all.push(p);
      });
      if (all.length < 3) {
        // last resort: the store's own product feed, so the slider is never empty
        fetchFeedProducts(12, function (extra) {
          extra.forEach(function (p) { if (!seen[p.url]) { seen[p.url] = true; p.match = !!matchedUrls[p.url]; all.push(p); } });
          showSlider(all);
        });
        return;
      }
      showSlider(all);
    }
    function showSlider(all) {
      currentGridProducts = all;
      var top = mixBrands(all)[0] || all[0];
      renderPriceCard(top);
      applySortAndRender();
    }
    // everything tagged for this loss level (any brand)
    fetchProductsByTag(tag, 10, function (list) {
      list.forEach(function (p) { matchedUrls[p.url] = true; pool.push(p); });
      done();
    });
    // per brand: the ones tagged for this loss level first, then that brand's other products
    brands.forEach(function (brand) {
      fetchProductsByTag(tag + ' ' + brand, perBrand, function (list) {
        list.forEach(function (p) { matchedUrls[p.url] = true; pool.push(p); });
        done();
      }, 'tag,vendor');
      fetchProductsByVendor(brand, perBrand, function (list) {
        list.forEach(function (p) { pool.push(p); });
        done();
      });
    });
  }

  // ---------- Manual product search (any product, e.g. by name or loss-level keyword) ----------
  function searchAllProducts(query, cb) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var raw = (d.resources && d.resources.results && d.resources.results.products) || [];
        cb(raw.map(function (p) {
          return {
            title: String(p.title || ''),
            url: p.url || ('/products/' + (p.handle || '')),
            price: Math.round(parseFloat(String(p.price || p.price_min || '0')) * 100),
            compare: Math.round(parseFloat(String(p.compare_at_price || p.compare_at_price_min || '0')) * 100),
            img: (p.featured_image && p.featured_image.url) ? (p.featured_image.url + '&width=160') : (p.image || '')
          };
        }));
      })
      .catch(function () { cb([]); });
  }

  var searchInput = root.querySelector('[data-recs-search-input]');
  var searchDrop = root.querySelector('[data-recs-search-drop]');
  var searchDebounce = null;

  searchInput.addEventListener('input', function () {
    var q = searchInput.value.trim();
    clearTimeout(searchDebounce);
    if (!q) { searchDrop.hidden = true; return; }
    searchDebounce = setTimeout(function () {
      searchAllProducts(q, function (results) {
        if (!results.length) {
          searchDrop.innerHTML = '<div class="hs-recs__search-empty">No products found for \u201c' + q.replace(/</g, '&lt;') + '\u201d</div>';
        } else {
          searchDrop.innerHTML = results.map(function (p, i) {
            return '<div class="hs-recs__search-item" data-search-idx="' + i + '">'
              + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '')
              + '<span>' + p.title.replace(/</g, '&lt;') + '</span>'
              + '<b>' + formatMoney(p.price) + '</b></div>';
          }).join('');
          window.__hsSearchResults = results;
          searchDrop.querySelectorAll('[data-search-idx]').forEach(function (el) {
            el.addEventListener('mousedown', function (e) {
              e.preventDefault();
              var product = window.__hsSearchResults[Number(el.getAttribute('data-search-idx'))];
              renderPriceCard(product);
              searchInput.value = product.title;
              searchDrop.hidden = true;
              root.querySelector('[data-price-card]').scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          });
        }
        searchDrop.hidden = false;
      });
    }, 250);
  });
  searchInput.addEventListener('blur', function () {
    setTimeout(function () { searchDrop.hidden = true; }, 200);
  });

  // ---------- Shop by brand (vendor-field search) ----------
  function fetchProductsByVendor(brand, limit, cb) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(brand)
      + '&resources[type]=product&resources[limit]=' + limit
      + '&resources[options][fields]=vendor'
      + '&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var raw = (d.resources && d.resources.results && d.resources.results.products) || [];
        cb(raw.map(function (p) {
          return {
            vendor: String(p.vendor || brand),
            title: String(p.title || ''),
            url: p.url || ('/products/' + (p.handle || '')),
            price: Math.round(parseFloat(String(p.price || p.price_min || '0')) * 100),
            compare: Math.round(parseFloat(String(p.compare_at_price || p.compare_at_price_min || '0')) * 100),
            img: (p.featured_image && p.featured_image.url) ? (p.featured_image.url + '&width=300') : (p.image || '')
          };
        }));
      })
      .catch(function (err) {
        console.error('HearSilk brand fetch error:', err);
        cb([]);
      });
  }

  function renderBrandGrid(products) {
    var grid = root.querySelector('[data-brand-grid]');
    if (!products.length) {
      grid.innerHTML = '<div class="hs-recs__empty">No products tagged with this brand\u2019s vendor yet.</div>';
      return;
    }
    grid.innerHTML = products.map(function (p) {
      var savePct = (p.compare > p.price && p.compare > 0) ? Math.round((p.compare - p.price) * 100 / p.compare) : 0;
      return '<a class="hs-rec-card" href="' + p.url + '">'
        + (p.img ? '<img class="hs-rec-card__img" src="' + p.img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '<div class="hs-rec-card__img"></div>')
        + '<div class="hs-rec-card__body">'
        + '<div class="hs-rec-card__title">' + p.title.replace(/</g, '&lt;') + '</div>'
        + '<div class="hs-rec-card__price-row">'
        + '<span class="hs-rec-card__price">' + formatMoney(p.price) + '</span>'
        + (p.compare > p.price ? '<span class="hs-rec-card__compare">' + formatMoney(p.compare) + '</span>' : '')
        + '</div>'
        + (savePct > 0 ? '<span class="hs-rec-card__save">Save ' + savePct + '%</span>' : '')
        + '</div></a>';
    }).join('');
  }

  var brandTabs = root.querySelectorAll('[data-brand-tab]');
  var brandCount = parseInt(root.getAttribute('data-brand-count') || '8', 10);
  var brandTabsInitialized = false;
  brandTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      brandTabs.forEach(function (t) { t.removeAttribute('data-active'); });
      tab.setAttribute('data-active', 'true');
      var grid = root.querySelector('[data-brand-grid]');
      grid.innerHTML = '<div class="hs-rec-card hs-rec-card--skeleton"></div><div class="hs-rec-card hs-rec-card--skeleton"></div><div class="hs-rec-card hs-rec-card--skeleton"></div>';
      fetchProductsByVendor(tab.getAttribute('data-brand-tab'), brandCount, renderBrandGrid);
    });
  });
  function initBrandTabsOnce() {
    if (!brandTabsInitialized && brandTabs.length) {
      brandTabsInitialized = true;
      brandTabs[0].click();
    }
  }

  // ---------- Results ----------
  var DEFAULT_REDFLAG = 'You mentioned a sudden hearing change or ear discomfort. Our hearing specialists will guide you personally — book a free consultation and we will take it from here.';
  var DEFAULT_ASYM = 'Your two ears hear a little differently. Our hearing specialists can explain what this means for you in a free consultation.';

  function renderResults() {
    var rightPta = earPta('right');
    var leftPta = earPta('left');
    var rightCat = categorize(rightPta);
    var leftCat = categorize(leftPta);
    var quality = computeQuality();
    var redFlag = state.answers.sudden === 'yes';
    var asym = Math.abs(rightPta - leftPta) >= 20;

    root.querySelector('[data-badge-right]').textContent = rightCat.label;
    root.querySelector('[data-badge-left]').textContent = leftCat.label;
    root.querySelector('[data-pta-right]').textContent = T('avg_text', r5(rightPta));
    root.querySelector('[data-pta-left]').textContent = T('avg_text', r5(leftPta));
    root.querySelector('[data-meaning-right]').textContent = T('meaning_' + rightCat.tone);
    root.querySelector('[data-meaning-left]').textContent = T('meaning_' + leftCat.tone);

    var baseRec = buildRecommendation(rightCat, leftCat);
    var fullRec = baseRec;
    if (redFlag) fullRec += ' ' + txt('data-redflag-text', DEFAULT_REDFLAG);
    if (asym) fullRec += ' ' + txt('data-asym-text', DEFAULT_ASYM);
    root.querySelector('[data-recommendation]').textContent = baseRec;

    // Red-flag and "ears differ" notes
    var flagBanner = root.querySelector('[data-redflag-banner]');
    flagBanner.hidden = !redFlag;
    flagBanner.querySelector('[data-redflag-text-el]').textContent = txt('data-redflag-text', DEFAULT_REDFLAG);
    var asymEl = root.querySelector('[data-asym-note]');
    asymEl.hidden = !asym;
    asymEl.textContent = txt('data-asym-text', DEFAULT_ASYM);

    // Confidence badge + reasons
    var conf = root.querySelector('[data-confidence]');
    conf.setAttribute('data-level', quality.level);
    var confDefaults = { high: 'High confidence', medium: 'Medium confidence', low: 'Low confidence' };
    root.querySelector('[data-conf-pill]').textContent = txt('data-conf-' + quality.level, confDefaults[quality.level]);
    var list = root.querySelector('[data-conf-reasons]');
    list.innerHTML = '';
    quality.reasons.forEach(function (r) {
      var li = document.createElement('li');
      li.setAttribute('data-ok', r.ok ? 'true' : 'false');
      li.textContent = r.text;
      list.appendChild(li);
    });
    root.querySelector('[data-conf-retake]').hidden = quality.level !== 'low';

    renderAudiogram();
    renderLevels();
    track('result_view', {
      confidence: quality.level, right_loss: rightCat.label, left_loss: leftCat.label,
      right_avg: r5(rightPta), left_avg: r5(leftPta), sudden_change: redFlag ? 'yes' : 'no'
    });

    var worstTone = [rightCat, leftCat].sort(function (a, b) {
      return ['good', 'mild', 'moderate', 'severe', 'profound'].indexOf(b.tone)
        - ['good', 'mild', 'moderate', 'severe', 'profound'].indexOf(a.tone);
    })[0].tone;

    loadRecommendations(worstTone);

    // The shop slider always stays visible: customers stay on our site. A sudden-change answer only adds the consultation banner.
    var shopBlocks = root.querySelectorAll('.hs-recs');
    shopBlocks.forEach(function (el) { el.hidden = false; });

    lastScoring = {
      rightAvg: rightPta, leftAvg: leftPta, rightCat: rightCat, leftCat: leftCat, worstTone: worstTone,
      quality: quality, redFlag: redFlag, asym: asym, recommendation: fullRec
    };
  }

  root.querySelector('[data-action="retake"]').addEventListener('click', function () { startOver('setup'); });

  // ---------- Contact form submit ----------
  var form = root.querySelector('[data-contact-form]');
  var errorEl = root.querySelector('[data-form-error]');
  var submitBtn = root.querySelector('[data-submit-btn]');
  var sentNote = root.querySelector('[data-sent-note]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;
    var formData = new FormData(form);
    var phoneDigits = (phoneLocalInput ? phoneLocalInput.value : '').replace(/\D/g, '');
    if (phoneDigits.length < 6) {
      errorEl.textContent = 'Please enter your phone number so our specialist can reach you.';
      errorEl.hidden = false;
      if (phoneLocalInput) { try { phoneLocalInput.focus(); } catch (e2) { /* no-op */ } }
      return;
    }
    var q = lastScoring.quality;
    var payload = {
      name: formData.get('name'),
      email: formData.get('email'),
      phone: (phoneLocalInput && phoneLocalInput.value.trim()) ? ('+' + detectedDialCode + ' ' + phoneLocalInput.value.trim()) : null,
      results: state.results,
      summary: {
        rightEar: lastScoring.rightCat.label,
        leftEar: lastScoring.leftCat.label,
        rightAvg: r5(lastScoring.rightAvg),   // average of 500 / 1k / 2k / 4k Hz
        leftAvg: r5(lastScoring.leftAvg)
      },
      recommendation: lastScoring.recommendation,
      browse_url: absoluteUrl(viewAllUrlFor(lastScoring.worstTone)),
      quality: {
        confidence: q.level,
        score: q.score,
        reasons: q.reasons.filter(function (r) { return !r.ok; }).map(function (r) { return r.text; }),
        headphones: state.setup.headphones,
        earCheck: state.setup.channel,
        roomNoise: state.setup.noise,
        catchTrials: state.catchTotal,
        falseAlarms: state.falseAlarms,
        strayTaps: state.spurious,
        noResponseCount: q.nrCount,
        retest: q.retest
      },
      answers: state.answers,
      flags: { redFlag: lastScoring.redFlag, earsDiffer: lastScoring.asym },
      submittedAt: new Date().toISOString(),
      website: formData.get('website') || '',
      shopDomain: window.Shopify ? window.Shopify.shop : null,
      context: Object.assign({}, analyticsContext, {
        testDurationSeconds: testStartedAt ? Math.round((Date.now() - testStartedAt) / 1000) : null
      })
    };

    submitBtn.disabled = true;
    submitBtn.textContent = T('sending_text');

    fetch(root.getAttribute('data-worker-endpoint'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        sentNote.hidden = false;
        leadSent = true;
        track('lead_submit', { confidence: lastScoring.quality.level, worst_loss: lastScoring.worstTone });
        track('generate_lead', { method: 'hearing_test', worst_loss: lastScoring.worstTone }, 'Lead');
        showScreen('results');
      })
      .catch(function (err) {
        errorEl.textContent = T('submit_error');
        errorEl.hidden = false;
        console.error('HearSilk audiometer submit error:', err);
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Generate my report';
      });
  });
  // ---------- PDF download (vector "blueprint" report) ----------
  function downloadPdfReport(contactInfo) {
    if (!window.jspdf || !window.jspdf.jsPDF) {
      alert('PDF generation is still loading \u2014 please wait a moment and try again.');
      return;
    }
    var doc = new window.jspdf.jsPDF({ unit: 'pt', format: 'letter' });
    var pageW = 612;
    var margin = 48;
    var y = margin;
    function ensureSpace(h) { if (y + h > 750) { doc.addPage(); y = margin; } }

    // ---- Header band ----
    doc.setFillColor(10, 79, 72);
    doc.rect(0, 0, pageW, 86, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(19);
    doc.setTextColor(255, 255, 255);
    doc.text('HearSilk Audiometry Test Report', margin, 40);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10.5);
    doc.setTextColor(207, 232, 223);
    var name = (contactInfo && contactInfo.name) ? contactInfo.name : '';
    doc.text('Name: ' + name + '   \u2022   Date: ' + new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }), margin, 62);
    y = 118;

    // ---- Vector audiogram chart (mirrors the on-page blueprint) ----
    var chartX = margin, chartY = y + 14, chartW = pageW - margin * 2, chartH = 220;
    var padL = 40, padR = 10, padT = 10, padB = 26;
    var plotX0 = chartX + padL, plotX1 = chartX + chartW - padR;
    var plotY0 = chartY + padT, plotY1 = chartY + chartH - padB;
    var plotW = plotX1 - plotX0, plotH = plotY1 - plotY0;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(76, 103, 100);
    doc.text('FREQUENCY (Hz)', chartX + chartW / 2, chartY - 4, { align: 'center' });
    doc.text('ESTIMATED LEVEL (dB)', chartX - 30, chartY + chartH / 2, { align: 'center', angle: 90 });

    function px(freq) {
      var minLog = Math.log10(AXIS_FREQUENCIES[0]);
      var maxLog = Math.log10(AXIS_FREQUENCIES[AXIS_FREQUENCIES.length - 1]);
      return plotX0 + ((Math.log10(freq) - minLog) / (maxLog - minLog)) * plotW;
    }
    function py(level) { return plotY0 + (level / 120) * plotH; }

    doc.setDrawColor(216, 230, 226);
    doc.setLineWidth(0.5);
    for (var lvl = 0; lvl <= 120; lvl += 5) {
      var gy = py(lvl);
      var major = (lvl % 20 === 0);
      doc.setDrawColor(major ? 200 : 230, major ? 216 : 238, major ? 210 : 234);
      doc.line(plotX0, gy, plotX1, gy);
      if (major) {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6.5);
        doc.setTextColor(76, 103, 100);
        doc.text(String(lvl), plotX0 - 5, gy + 2, { align: 'right' });
      }
    }
    AXIS_FREQUENCIES.forEach(function (f) {
      var gx = px(f);
      var isTested = FREQUENCIES.indexOf(f) !== -1;
      if (isTested) { doc.setLineDashPattern([], 0); doc.setDrawColor(200, 216, 210); }
      else { doc.setLineDashPattern([2, 2], 0); doc.setDrawColor(230, 238, 234); }
      doc.line(gx, plotY0, gx, plotY1);
      doc.setLineDashPattern([], 0);
      doc.setFont('helvetica', isTested ? 'bold' : 'normal');
      doc.setFontSize(isTested ? 6.5 : 5.5);
      doc.setTextColor(76, 103, 100);
      doc.text(String(f), gx, plotY1 + 12, { align: 'center' });
    });

    ['right', 'left'].forEach(function (ear) {
      var pts = FREQUENCIES.map(function (f) {
        var r = state.results.find(function (res) { return res.ear === ear && res.freq === f; });
        return { x: px(f), y: py(r ? r.level : 0) };
      });
      var isRight = ear === 'right';
      if (isRight) doc.setDrawColor(214, 72, 44); else doc.setDrawColor(14, 110, 100);
      doc.setLineWidth(1.1);
      for (var i = 0; i < pts.length - 1; i++) doc.line(pts[i].x, pts[i].y, pts[i + 1].x, pts[i + 1].y);
      pts.forEach(function (p) {
        if (isRight) {
          doc.circle(p.x, p.y, 4, 'S');
        } else {
          doc.line(p.x - 4, p.y - 4, p.x + 4, p.y + 4);
          doc.line(p.x - 4, p.y + 4, p.x + 4, p.y - 4);
        }
      });
    });

    doc.setFontSize(9);
    doc.setTextColor(214, 72, 44);
    doc.text('O  Right ear', chartX, chartY + chartH + 14);
    doc.setTextColor(14, 110, 100);
    doc.text('X  Left ear', chartX + 80, chartY + chartH + 14);

    y = chartY + chartH + 34;

    // ---- Summary badges ----
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(30, 30, 30);
    doc.text('Right ear: ' + lastScoring.rightCat.label + '  (average ' + Math.round(lastScoring.rightAvg) + ' dB)', margin, y); y += 16;
    doc.text('Left ear: ' + lastScoring.leftCat.label + '  (average ' + Math.round(lastScoring.leftAvg) + ' dB)', margin, y); y += 16;
    var confLabel = { high: 'High', medium: 'Medium', low: 'Low' }[lastScoring.quality.level] || '';
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    doc.setTextColor(76, 103, 100);
    doc.text('Averages use 500, 1000, 2000 and 4000 Hz.   Test confidence: ' + confLabel, margin, y); y += 22;
    doc.setTextColor(30, 30, 30);

    // ---- Data table ----
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9.5);
    doc.text('Frequency', margin, y);
    doc.text('Ear', margin + 140, y);
    doc.text('Estimated level (dB)', margin + 220, y);
    y += 6;
    doc.setDrawColor(216, 230, 226);
    doc.line(margin, y, margin + 320, y);
    y += 14;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    state.results.forEach(function (r) {
      doc.text(r.freq + ' Hz', margin, y);
      doc.text(r.ear.charAt(0).toUpperCase() + r.ear.slice(1), margin + 140, y);
      doc.text(r.noResponse ? ('Above ' + (r.maxL || 120) + ' dB') : (r.level + ' dB'), margin + 220, y);
      y += 13;
    });
    y += 12;

    // ---- Recommendation ----
    ensureSpace(140);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10.5);
    doc.text('Recommendation', margin, y); y += 15;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9.5);
    var recText = lastScoring.recommendation;
    var recLines = doc.splitTextToSize(recText, 500);
    doc.text(recLines, margin, y);
    y += recLines.length * 12 + 16;

    // ---- Recommended products (as clickable links) ----
    var cards = root.querySelectorAll('[data-recs-grid] .hs-rec-card');
    if (cards.length) {
      ensureSpace(60);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10.5);
      doc.text('Recommended for you', margin, y); y += 15;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9.5);
      doc.setTextColor(14, 110, 100);
      cards.forEach(function (card) {
        var title = card.querySelector('.hs-rec-card__title');
        var price = card.querySelector('.hs-rec-card__price');
        if (!title) return;
        ensureSpace(20);
        var label = title.textContent + (price ? ' \u2014 ' + price.textContent : '');
        doc.textWithLink(label, margin, y, { url: card.href });
        y += 14;
      });
      doc.setTextColor(30, 30, 30);
      y += 10;
    }

    // ---- Disclaimer ----
    ensureSpace(60);
    doc.setFontSize(8.5);
    doc.setTextColor(110, 110, 110);
    var disclaimerLines = doc.splitTextToSize(
      'This is an online audiometry test that depends on your device and environment; it is not a substitute for a clinical audiometer test, and numbers can be off by 10-15 dB on some headphones. For a detailed assessment, book a free consultation with our hearing specialists.',
      500
    );
    doc.text(disclaimerLines, margin, y);

    doc.save('hearsilk-hearing-report.pdf');
  }

  root.querySelector('[data-action="download-pdf"]').addEventListener('click', function () {
    var formData = new FormData(form);
    downloadPdfReport({ name: formData.get('name') });
  });

})();